(() => {

      var $parcel$global = globalThis;
    // custom elements
function $19c6026a5085889c$var$isNumber(subject) {
    return typeof subject === "number";
}
function $19c6026a5085889c$var$isString(subject) {
    return typeof subject === "string";
}
function $19c6026a5085889c$var$isBoolean(subject) {
    return typeof subject === "boolean";
}
function $19c6026a5085889c$var$isObject(subject) {
    return Object.prototype.toString.call(subject) === "[object Object]";
}
function $19c6026a5085889c$var$mathAbs(n) {
    return Math.abs(n);
}
function $19c6026a5085889c$var$mathSign(n) {
    return Math.sign(n);
}
function $19c6026a5085889c$var$deltaAbs(valueB, valueA) {
    return $19c6026a5085889c$var$mathAbs(valueB - valueA);
}
function $19c6026a5085889c$var$factorAbs(valueB, valueA) {
    if (valueB === 0 || valueA === 0) return 0;
    if ($19c6026a5085889c$var$mathAbs(valueB) <= $19c6026a5085889c$var$mathAbs(valueA)) return 0;
    const diff = $19c6026a5085889c$var$deltaAbs($19c6026a5085889c$var$mathAbs(valueB), $19c6026a5085889c$var$mathAbs(valueA));
    return $19c6026a5085889c$var$mathAbs(diff / valueB);
}
function $19c6026a5085889c$var$arrayKeys(array) {
    return $19c6026a5085889c$var$objectKeys(array).map(Number);
}
function $19c6026a5085889c$var$arrayLast(array) {
    return array[$19c6026a5085889c$var$arrayLastIndex(array)];
}
function $19c6026a5085889c$var$arrayLastIndex(array) {
    return Math.max(0, array.length - 1);
}
function $19c6026a5085889c$var$arrayIsLastIndex(array, index) {
    return index === $19c6026a5085889c$var$arrayLastIndex(array);
}
function $19c6026a5085889c$var$arrayFromNumber(n, startAt = 0) {
    return Array.from(Array(n), (_, i)=>startAt + i);
}
function $19c6026a5085889c$var$objectKeys(object) {
    return Object.keys(object);
}
function $19c6026a5085889c$var$objectsMergeDeep(objectA, objectB) {
    return [
        objectA,
        objectB
    ].reduce((mergedObjects, currentObject)=>{
        $19c6026a5085889c$var$objectKeys(currentObject).forEach((key)=>{
            const valueA = mergedObjects[key];
            const valueB = currentObject[key];
            const areObjects = $19c6026a5085889c$var$isObject(valueA) && $19c6026a5085889c$var$isObject(valueB);
            mergedObjects[key] = areObjects ? $19c6026a5085889c$var$objectsMergeDeep(valueA, valueB) : valueB;
        });
        return mergedObjects;
    }, {});
}
function $19c6026a5085889c$var$isMouseEvent(evt, ownerWindow) {
    return typeof ownerWindow.MouseEvent !== "undefined" && evt instanceof ownerWindow.MouseEvent;
}
function $19c6026a5085889c$var$Alignment(align, viewSize) {
    const predefined = {
        start: start,
        center: center,
        end: end
    };
    function start() {
        return 0;
    }
    function center(n) {
        return end(n) / 2;
    }
    function end(n) {
        return viewSize - n;
    }
    function measure(n, index) {
        if ($19c6026a5085889c$var$isString(align)) return predefined[align](n);
        return align(viewSize, n, index);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $19c6026a5085889c$var$EventStore() {
    let listeners = [];
    function add(node, type, handler, options = {
        passive: true
    }) {
        let removeListener;
        if ("addEventListener" in node) {
            node.addEventListener(type, handler, options);
            removeListener = ()=>node.removeEventListener(type, handler, options);
        } else {
            const legacyMediaQueryList = node;
            legacyMediaQueryList.addListener(handler);
            removeListener = ()=>legacyMediaQueryList.removeListener(handler);
        }
        listeners.push(removeListener);
        return self;
    }
    function clear() {
        listeners = listeners.filter((remove)=>remove());
    }
    const self = {
        add: add,
        clear: clear
    };
    return self;
}
function $19c6026a5085889c$var$Animations(ownerDocument, ownerWindow, update, render) {
    const documentVisibleHandler = $19c6026a5085889c$var$EventStore();
    const timeStep = 1000 / 60;
    let lastTimeStamp = null;
    let lag = 0;
    let animationFrame = 0;
    function init() {
        documentVisibleHandler.add(ownerDocument, "visibilitychange", ()=>{
            if (ownerDocument.hidden) reset();
        });
    }
    function destroy() {
        stop();
        documentVisibleHandler.clear();
    }
    function animate(timeStamp) {
        if (!animationFrame) return;
        if (!lastTimeStamp) lastTimeStamp = timeStamp;
        const elapsed = timeStamp - lastTimeStamp;
        lastTimeStamp = timeStamp;
        lag += elapsed;
        while(lag >= timeStep){
            update(timeStep);
            lag -= timeStep;
        }
        const lagOffset = lag / timeStep;
        render(lagOffset);
        if (animationFrame) ownerWindow.requestAnimationFrame(animate);
    }
    function start() {
        if (animationFrame) return;
        animationFrame = ownerWindow.requestAnimationFrame(animate);
    }
    function stop() {
        ownerWindow.cancelAnimationFrame(animationFrame);
        lastTimeStamp = null;
        lag = 0;
        animationFrame = 0;
    }
    function reset() {
        lastTimeStamp = null;
        lag = 0;
    }
    const self = {
        init: init,
        destroy: destroy,
        start: start,
        stop: stop,
        update: ()=>update(timeStep),
        render: render
    };
    return self;
}
function $19c6026a5085889c$var$Axis(axis, contentDirection) {
    const isRightToLeft = contentDirection === "rtl";
    const isVertical = axis === "y";
    const scroll = isVertical ? "y" : "x";
    const cross = isVertical ? "x" : "y";
    const sign = !isVertical && isRightToLeft ? -1 : 1;
    const startEdge = getStartEdge();
    const endEdge = getEndEdge();
    function measureSize(nodeRect) {
        const { height: height, width: width } = nodeRect;
        return isVertical ? height : width;
    }
    function getStartEdge() {
        if (isVertical) return "top";
        return isRightToLeft ? "right" : "left";
    }
    function getEndEdge() {
        if (isVertical) return "bottom";
        return isRightToLeft ? "left" : "right";
    }
    function direction(n) {
        return n * sign;
    }
    const self = {
        scroll: scroll,
        cross: cross,
        startEdge: startEdge,
        endEdge: endEdge,
        measureSize: measureSize,
        direction: direction
    };
    return self;
}
function $19c6026a5085889c$var$Limit(min = 0, max = 0) {
    const length = $19c6026a5085889c$var$mathAbs(min - max);
    function reachedMin(n) {
        return n < min;
    }
    function reachedMax(n) {
        return n > max;
    }
    function reachedAny(n) {
        return reachedMin(n) || reachedMax(n);
    }
    function constrain(n) {
        if (!reachedAny(n)) return n;
        return reachedMin(n) ? min : max;
    }
    function removeOffset(n) {
        if (!length) return n;
        return n - length * Math.ceil((n - max) / length);
    }
    const self = {
        length: length,
        max: max,
        min: min,
        constrain: constrain,
        reachedAny: reachedAny,
        reachedMax: reachedMax,
        reachedMin: reachedMin,
        removeOffset: removeOffset
    };
    return self;
}
function $19c6026a5085889c$var$Counter(max, start, loop) {
    const { constrain: constrain } = $19c6026a5085889c$var$Limit(0, max);
    const loopEnd = max + 1;
    let counter = withinLimit(start);
    function withinLimit(n) {
        return !loop ? constrain(n) : $19c6026a5085889c$var$mathAbs((loopEnd + n) % loopEnd);
    }
    function get() {
        return counter;
    }
    function set(n) {
        counter = withinLimit(n);
        return self;
    }
    function add(n) {
        return clone().set(get() + n);
    }
    function clone() {
        return $19c6026a5085889c$var$Counter(max, get(), loop);
    }
    const self = {
        get: get,
        set: set,
        add: add,
        clone: clone
    };
    return self;
}
function $19c6026a5085889c$var$DragHandler(axis, rootNode, ownerDocument, ownerWindow, target, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, baseFriction, watchDrag) {
    const { cross: crossAxis, direction: direction } = axis;
    const focusNodes = [
        "INPUT",
        "SELECT",
        "TEXTAREA"
    ];
    const nonPassiveEvent = {
        passive: false
    };
    const initEvents = $19c6026a5085889c$var$EventStore();
    const dragEvents = $19c6026a5085889c$var$EventStore();
    const goToNextThreshold = $19c6026a5085889c$var$Limit(50, 225).constrain(percentOfView.measure(20));
    const snapForceBoost = {
        mouse: 300,
        touch: 400
    };
    const freeForceBoost = {
        mouse: 500,
        touch: 600
    };
    const baseSpeed = dragFree ? 43 : 25;
    let isMoving = false;
    let startScroll = 0;
    let startCross = 0;
    let pointerIsDown = false;
    let preventScroll = false;
    let preventClick = false;
    let isMouse = false;
    function init(emblaApi) {
        if (!watchDrag) return;
        function downIfAllowed(evt) {
            if ($19c6026a5085889c$var$isBoolean(watchDrag) || watchDrag(emblaApi, evt)) down(evt);
        }
        const node = rootNode;
        initEvents.add(node, "dragstart", (evt)=>evt.preventDefault(), nonPassiveEvent).add(node, "touchmove", ()=>undefined, nonPassiveEvent).add(node, "touchend", ()=>undefined).add(node, "touchstart", downIfAllowed).add(node, "mousedown", downIfAllowed).add(node, "touchcancel", up).add(node, "contextmenu", up).add(node, "click", click, true);
    }
    function destroy() {
        initEvents.clear();
        dragEvents.clear();
    }
    function addDragEvents() {
        const node = isMouse ? ownerDocument : rootNode;
        dragEvents.add(node, "touchmove", move, nonPassiveEvent).add(node, "touchend", up).add(node, "mousemove", move, nonPassiveEvent).add(node, "mouseup", up);
    }
    function isFocusNode(node) {
        const nodeName = node.nodeName || "";
        return focusNodes.includes(nodeName);
    }
    function forceBoost() {
        const boost = dragFree ? freeForceBoost : snapForceBoost;
        const type = isMouse ? "mouse" : "touch";
        return boost[type];
    }
    function allowedForce(force, targetChanged) {
        const next = index.add($19c6026a5085889c$var$mathSign(force) * -1);
        const baseForce = scrollTarget.byDistance(force, !dragFree).distance;
        if (dragFree || $19c6026a5085889c$var$mathAbs(force) < goToNextThreshold) return baseForce;
        if (skipSnaps && targetChanged) return baseForce * 0.5;
        return scrollTarget.byIndex(next.get(), 0).distance;
    }
    function down(evt) {
        const isMouseEvt = $19c6026a5085889c$var$isMouseEvent(evt, ownerWindow);
        isMouse = isMouseEvt;
        preventClick = dragFree && isMouseEvt && !evt.buttons && isMoving;
        isMoving = $19c6026a5085889c$var$deltaAbs(target.get(), location.get()) >= 2;
        if (isMouseEvt && evt.button !== 0) return;
        if (isFocusNode(evt.target)) return;
        pointerIsDown = true;
        dragTracker.pointerDown(evt);
        scrollBody.useFriction(0).useDuration(0);
        target.set(location);
        addDragEvents();
        startScroll = dragTracker.readPoint(evt);
        startCross = dragTracker.readPoint(evt, crossAxis);
        eventHandler.emit("pointerDown");
    }
    function move(evt) {
        const isTouchEvt = !$19c6026a5085889c$var$isMouseEvent(evt, ownerWindow);
        if (isTouchEvt && evt.touches.length >= 2) return up(evt);
        const lastScroll = dragTracker.readPoint(evt);
        const lastCross = dragTracker.readPoint(evt, crossAxis);
        const diffScroll = $19c6026a5085889c$var$deltaAbs(lastScroll, startScroll);
        const diffCross = $19c6026a5085889c$var$deltaAbs(lastCross, startCross);
        if (!preventScroll && !isMouse) {
            if (!evt.cancelable) return up(evt);
            preventScroll = diffScroll > diffCross;
            if (!preventScroll) return up(evt);
        }
        const diff = dragTracker.pointerMove(evt);
        if (diffScroll > dragThreshold) preventClick = true;
        scrollBody.useFriction(0.3).useDuration(0.75);
        animation.start();
        target.add(direction(diff));
        evt.preventDefault();
    }
    function up(evt) {
        const currentLocation = scrollTarget.byDistance(0, false);
        const targetChanged = currentLocation.index !== index.get();
        const rawForce = dragTracker.pointerUp(evt) * forceBoost();
        const force = allowedForce(direction(rawForce), targetChanged);
        const forceFactor = $19c6026a5085889c$var$factorAbs(rawForce, force);
        const speed = baseSpeed - 10 * forceFactor;
        const friction = baseFriction + forceFactor / 50;
        preventScroll = false;
        pointerIsDown = false;
        dragEvents.clear();
        scrollBody.useDuration(speed).useFriction(friction);
        scrollTo.distance(force, !dragFree);
        isMouse = false;
        eventHandler.emit("pointerUp");
    }
    function click(evt) {
        if (preventClick) {
            evt.stopPropagation();
            evt.preventDefault();
            preventClick = false;
        }
    }
    function pointerDown() {
        return pointerIsDown;
    }
    const self = {
        init: init,
        destroy: destroy,
        pointerDown: pointerDown
    };
    return self;
}
function $19c6026a5085889c$var$DragTracker(axis, ownerWindow) {
    const logInterval = 170;
    let startEvent;
    let lastEvent;
    function readTime(evt) {
        return evt.timeStamp;
    }
    function readPoint(evt, evtAxis) {
        const property = evtAxis || axis.scroll;
        const coord = `client${property === "x" ? "X" : "Y"}`;
        return ($19c6026a5085889c$var$isMouseEvent(evt, ownerWindow) ? evt : evt.touches[0])[coord];
    }
    function pointerDown(evt) {
        startEvent = evt;
        lastEvent = evt;
        return readPoint(evt);
    }
    function pointerMove(evt) {
        const diff = readPoint(evt) - readPoint(lastEvent);
        const expired = readTime(evt) - readTime(startEvent) > logInterval;
        lastEvent = evt;
        if (expired) startEvent = evt;
        return diff;
    }
    function pointerUp(evt) {
        if (!startEvent || !lastEvent) return 0;
        const diffDrag = readPoint(lastEvent) - readPoint(startEvent);
        const diffTime = readTime(evt) - readTime(startEvent);
        const expired = readTime(evt) - readTime(lastEvent) > logInterval;
        const force = diffDrag / diffTime;
        const isFlick = diffTime && !expired && $19c6026a5085889c$var$mathAbs(force) > 0.1;
        return isFlick ? force : 0;
    }
    const self = {
        pointerDown: pointerDown,
        pointerMove: pointerMove,
        pointerUp: pointerUp,
        readPoint: readPoint
    };
    return self;
}
function $19c6026a5085889c$var$NodeRects() {
    function measure(node) {
        const { offsetTop: offsetTop, offsetLeft: offsetLeft, offsetWidth: offsetWidth, offsetHeight: offsetHeight } = node;
        const offset = {
            top: offsetTop,
            right: offsetLeft + offsetWidth,
            bottom: offsetTop + offsetHeight,
            left: offsetLeft,
            width: offsetWidth,
            height: offsetHeight
        };
        return offset;
    }
    const self = {
        measure: measure
    };
    return self;
}
function $19c6026a5085889c$var$PercentOfView(viewSize) {
    function measure(n) {
        return viewSize * (n / 100);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $19c6026a5085889c$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects) {
    const observeNodes = [
        container
    ].concat(slides);
    let resizeObserver;
    let containerSize;
    let slideSizes = [];
    let destroyed = false;
    function readSize(node) {
        return axis.measureSize(nodeRects.measure(node));
    }
    function init(emblaApi) {
        if (!watchResize) return;
        containerSize = readSize(container);
        slideSizes = slides.map(readSize);
        function defaultCallback(entries) {
            for (const entry of entries){
                if (destroyed) return;
                const isContainer = entry.target === container;
                const slideIndex = slides.indexOf(entry.target);
                const lastSize = isContainer ? containerSize : slideSizes[slideIndex];
                const newSize = readSize(isContainer ? container : slides[slideIndex]);
                const diffSize = $19c6026a5085889c$var$mathAbs(newSize - lastSize);
                if (diffSize >= 0.5) {
                    emblaApi.reInit();
                    eventHandler.emit("resize");
                    break;
                }
            }
        }
        resizeObserver = new ResizeObserver((entries)=>{
            if ($19c6026a5085889c$var$isBoolean(watchResize) || watchResize(emblaApi, entries)) defaultCallback(entries);
        });
        ownerWindow.requestAnimationFrame(()=>{
            observeNodes.forEach((node)=>resizeObserver.observe(node));
        });
    }
    function destroy() {
        destroyed = true;
        if (resizeObserver) resizeObserver.disconnect();
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $19c6026a5085889c$var$ScrollBody(location, offsetLocation, previousLocation, target, baseDuration, baseFriction) {
    let bodyVelocity = 0;
    let scrollDirection = 0;
    let scrollDuration = baseDuration;
    let scrollFriction = baseFriction;
    let rawLocation = location.get();
    let rawLocationPrevious = 0;
    function seek(timeStep) {
        const fixedDeltaTimeSeconds = timeStep / 1000;
        const duration = scrollDuration * fixedDeltaTimeSeconds;
        const diff = target.get() - location.get();
        const isInstant = !scrollDuration;
        let directionDiff = 0;
        if (isInstant) {
            bodyVelocity = 0;
            previousLocation.set(target);
            location.set(target);
            directionDiff = diff;
        } else {
            previousLocation.set(location);
            bodyVelocity += diff / duration;
            bodyVelocity *= scrollFriction;
            rawLocation += bodyVelocity;
            location.add(bodyVelocity * fixedDeltaTimeSeconds);
            directionDiff = rawLocation - rawLocationPrevious;
        }
        scrollDirection = $19c6026a5085889c$var$mathSign(directionDiff);
        rawLocationPrevious = rawLocation;
        return self;
    }
    function settled() {
        const diff = target.get() - offsetLocation.get();
        return $19c6026a5085889c$var$mathAbs(diff) < 0.001;
    }
    function duration() {
        return scrollDuration;
    }
    function direction() {
        return scrollDirection;
    }
    function velocity() {
        return bodyVelocity;
    }
    function useBaseDuration() {
        return useDuration(baseDuration);
    }
    function useBaseFriction() {
        return useFriction(baseFriction);
    }
    function useDuration(n) {
        scrollDuration = n;
        return self;
    }
    function useFriction(n) {
        scrollFriction = n;
        return self;
    }
    const self = {
        direction: direction,
        duration: duration,
        velocity: velocity,
        seek: seek,
        settled: settled,
        useBaseFriction: useBaseFriction,
        useBaseDuration: useBaseDuration,
        useFriction: useFriction,
        useDuration: useDuration
    };
    return self;
}
function $19c6026a5085889c$var$ScrollBounds(limit, location, target, scrollBody, percentOfView) {
    const pullBackThreshold = percentOfView.measure(10);
    const edgeOffsetTolerance = percentOfView.measure(50);
    const frictionLimit = $19c6026a5085889c$var$Limit(0.1, 0.99);
    let disabled = false;
    function shouldConstrain() {
        if (disabled) return false;
        if (!limit.reachedAny(target.get())) return false;
        if (!limit.reachedAny(location.get())) return false;
        return true;
    }
    function constrain(pointerDown) {
        if (!shouldConstrain()) return;
        const edge = limit.reachedMin(location.get()) ? "min" : "max";
        const diffToEdge = $19c6026a5085889c$var$mathAbs(limit[edge] - location.get());
        const diffToTarget = target.get() - location.get();
        const friction = frictionLimit.constrain(diffToEdge / edgeOffsetTolerance);
        target.subtract(diffToTarget * friction);
        if (!pointerDown && $19c6026a5085889c$var$mathAbs(diffToTarget) < pullBackThreshold) {
            target.set(limit.constrain(target.get()));
            scrollBody.useDuration(25).useBaseFriction();
        }
    }
    function toggleActive(active) {
        disabled = !active;
    }
    const self = {
        shouldConstrain: shouldConstrain,
        constrain: constrain,
        toggleActive: toggleActive
    };
    return self;
}
function $19c6026a5085889c$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance) {
    const scrollBounds = $19c6026a5085889c$var$Limit(-contentSize + viewSize, 0);
    const snapsBounded = measureBounded();
    const scrollContainLimit = findScrollContainLimit();
    const snapsContained = measureContained();
    function usePixelTolerance(bound, snap) {
        return $19c6026a5085889c$var$deltaAbs(bound, snap) < 1;
    }
    function findScrollContainLimit() {
        const startSnap = snapsBounded[0];
        const endSnap = $19c6026a5085889c$var$arrayLast(snapsBounded);
        const min = snapsBounded.lastIndexOf(startSnap);
        const max = snapsBounded.indexOf(endSnap) + 1;
        return $19c6026a5085889c$var$Limit(min, max);
    }
    function measureBounded() {
        return snapsAligned.map((snapAligned, index)=>{
            const { min: min, max: max } = scrollBounds;
            const snap = scrollBounds.constrain(snapAligned);
            const isFirst = !index;
            const isLast = $19c6026a5085889c$var$arrayIsLastIndex(snapsAligned, index);
            if (isFirst) return max;
            if (isLast) return min;
            if (usePixelTolerance(min, snap)) return min;
            if (usePixelTolerance(max, snap)) return max;
            return snap;
        }).map((scrollBound)=>parseFloat(scrollBound.toFixed(3)));
    }
    function measureContained() {
        if (contentSize <= viewSize + pixelTolerance) return [
            scrollBounds.max
        ];
        if (containScroll === "keepSnaps") return snapsBounded;
        const { min: min, max: max } = scrollContainLimit;
        return snapsBounded.slice(min, max);
    }
    const self = {
        snapsContained: snapsContained,
        scrollContainLimit: scrollContainLimit
    };
    return self;
}
function $19c6026a5085889c$var$ScrollLimit(contentSize, scrollSnaps, loop) {
    const max = scrollSnaps[0];
    const min = loop ? max - contentSize : $19c6026a5085889c$var$arrayLast(scrollSnaps);
    const limit = $19c6026a5085889c$var$Limit(min, max);
    const self = {
        limit: limit
    };
    return self;
}
function $19c6026a5085889c$var$ScrollLooper(contentSize, limit, location, vectors) {
    const jointSafety = 0.1;
    const min = limit.min + jointSafety;
    const max = limit.max + jointSafety;
    const { reachedMin: reachedMin, reachedMax: reachedMax } = $19c6026a5085889c$var$Limit(min, max);
    function shouldLoop(direction) {
        if (direction === 1) return reachedMax(location.get());
        if (direction === -1) return reachedMin(location.get());
        return false;
    }
    function loop(direction) {
        if (!shouldLoop(direction)) return;
        const loopDistance = contentSize * (direction * -1);
        vectors.forEach((v)=>v.add(loopDistance));
    }
    const self = {
        loop: loop
    };
    return self;
}
function $19c6026a5085889c$var$ScrollProgress(limit) {
    const { max: max, length: length } = limit;
    function get(n) {
        const currentLocation = n - max;
        return length ? currentLocation / -length : 0;
    }
    const self = {
        get: get
    };
    return self;
}
function $19c6026a5085889c$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll) {
    const { startEdge: startEdge, endEdge: endEdge } = axis;
    const { groupSlides: groupSlides } = slidesToScroll;
    const alignments = measureSizes().map(alignment.measure);
    const snaps = measureUnaligned();
    const snapsAligned = measureAligned();
    function measureSizes() {
        return groupSlides(slideRects).map((rects)=>$19c6026a5085889c$var$arrayLast(rects)[endEdge] - rects[0][startEdge]).map($19c6026a5085889c$var$mathAbs);
    }
    function measureUnaligned() {
        return slideRects.map((rect)=>containerRect[startEdge] - rect[startEdge]).map((snap)=>-$19c6026a5085889c$var$mathAbs(snap));
    }
    function measureAligned() {
        return groupSlides(snaps).map((g)=>g[0]).map((snap, index)=>snap + alignments[index]);
    }
    const self = {
        snaps: snaps,
        snapsAligned: snapsAligned
    };
    return self;
}
function $19c6026a5085889c$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes) {
    const { groupSlides: groupSlides } = slidesToScroll;
    const { min: min, max: max } = scrollContainLimit;
    const slideRegistry = createSlideRegistry();
    function createSlideRegistry() {
        const groupedSlideIndexes = groupSlides(slideIndexes);
        const doNotContain = !containSnaps || containScroll === "keepSnaps";
        if (scrollSnaps.length === 1) return [
            slideIndexes
        ];
        if (doNotContain) return groupedSlideIndexes;
        return groupedSlideIndexes.slice(min, max).map((group, index, groups)=>{
            const isFirst = !index;
            const isLast = $19c6026a5085889c$var$arrayIsLastIndex(groups, index);
            if (isFirst) {
                const range = $19c6026a5085889c$var$arrayLast(groups[0]) + 1;
                return $19c6026a5085889c$var$arrayFromNumber(range);
            }
            if (isLast) {
                const range = $19c6026a5085889c$var$arrayLastIndex(slideIndexes) - $19c6026a5085889c$var$arrayLast(groups)[0] + 1;
                return $19c6026a5085889c$var$arrayFromNumber(range, $19c6026a5085889c$var$arrayLast(groups)[0]);
            }
            return group;
        });
    }
    const self = {
        slideRegistry: slideRegistry
    };
    return self;
}
function $19c6026a5085889c$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
    const { reachedAny: reachedAny, removeOffset: removeOffset, constrain: constrain } = limit;
    function minDistance(distances) {
        return distances.concat().sort((a, b)=>$19c6026a5085889c$var$mathAbs(a) - $19c6026a5085889c$var$mathAbs(b))[0];
    }
    function findTargetSnap(target) {
        const distance = loop ? removeOffset(target) : constrain(target);
        const ascDiffsToSnaps = scrollSnaps.map((snap, index)=>({
                diff: shortcut(snap - distance, 0),
                index: index
            })).sort((d1, d2)=>$19c6026a5085889c$var$mathAbs(d1.diff) - $19c6026a5085889c$var$mathAbs(d2.diff));
        const { index: index } = ascDiffsToSnaps[0];
        return {
            index: index,
            distance: distance
        };
    }
    function shortcut(target, direction) {
        const targets = [
            target,
            target + contentSize,
            target - contentSize
        ];
        if (!loop) return target;
        if (!direction) return minDistance(targets);
        const matchingTargets = targets.filter((t)=>$19c6026a5085889c$var$mathSign(t) === direction);
        if (matchingTargets.length) return minDistance(matchingTargets);
        return $19c6026a5085889c$var$arrayLast(targets) - contentSize;
    }
    function byIndex(index, direction) {
        const diffToSnap = scrollSnaps[index] - targetVector.get();
        const distance = shortcut(diffToSnap, direction);
        return {
            index: index,
            distance: distance
        };
    }
    function byDistance(distance, snap) {
        const target = targetVector.get() + distance;
        const { index: index, distance: targetSnapDistance } = findTargetSnap(target);
        const reachedBound = !loop && reachedAny(target);
        if (!snap || reachedBound) return {
            index: index,
            distance: distance
        };
        const diffToSnap = scrollSnaps[index] - targetSnapDistance;
        const snapDistance = distance + shortcut(diffToSnap, 0);
        return {
            index: index,
            distance: snapDistance
        };
    }
    const self = {
        byDistance: byDistance,
        byIndex: byIndex,
        shortcut: shortcut
    };
    return self;
}
function $19c6026a5085889c$var$ScrollTo(animation, indexCurrent, indexPrevious, scrollBody, scrollTarget, targetVector, eventHandler) {
    function scrollTo(target) {
        const distanceDiff = target.distance;
        const indexDiff = target.index !== indexCurrent.get();
        targetVector.add(distanceDiff);
        if (distanceDiff) {
            if (scrollBody.duration()) animation.start();
            else {
                animation.update();
                animation.render(1);
                animation.update();
            }
        }
        if (indexDiff) {
            indexPrevious.set(indexCurrent.get());
            indexCurrent.set(target.index);
            eventHandler.emit("select");
        }
    }
    function distance(n, snap) {
        const target = scrollTarget.byDistance(n, snap);
        scrollTo(target);
    }
    function index(n, direction) {
        const targetIndex = indexCurrent.clone().set(n);
        const target = scrollTarget.byIndex(targetIndex.get(), direction);
        scrollTo(target);
    }
    const self = {
        distance: distance,
        index: index
    };
    return self;
}
function $19c6026a5085889c$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus) {
    const focusListenerOptions = {
        passive: true,
        capture: true
    };
    let lastTabPressTime = 0;
    function init(emblaApi) {
        if (!watchFocus) return;
        function defaultCallback(index) {
            const nowTime = new Date().getTime();
            const diffTime = nowTime - lastTabPressTime;
            if (diffTime > 10) return;
            eventHandler.emit("slideFocusStart");
            root.scrollLeft = 0;
            const group = slideRegistry.findIndex((group)=>group.includes(index));
            if (!$19c6026a5085889c$var$isNumber(group)) return;
            scrollBody.useDuration(0);
            scrollTo.index(group, 0);
            eventHandler.emit("slideFocus");
        }
        eventStore.add(document, "keydown", registerTabPress, false);
        slides.forEach((slide, slideIndex)=>{
            eventStore.add(slide, "focus", (evt)=>{
                if ($19c6026a5085889c$var$isBoolean(watchFocus) || watchFocus(emblaApi, evt)) defaultCallback(slideIndex);
            }, focusListenerOptions);
        });
    }
    function registerTabPress(event) {
        if (event.code === "Tab") lastTabPressTime = new Date().getTime();
    }
    const self = {
        init: init
    };
    return self;
}
function $19c6026a5085889c$var$Vector1D(initialValue) {
    let value = initialValue;
    function get() {
        return value;
    }
    function set(n) {
        value = normalizeInput(n);
    }
    function add(n) {
        value += normalizeInput(n);
    }
    function subtract(n) {
        value -= normalizeInput(n);
    }
    function normalizeInput(n) {
        return $19c6026a5085889c$var$isNumber(n) ? n : n.get();
    }
    const self = {
        get: get,
        set: set,
        add: add,
        subtract: subtract
    };
    return self;
}
function $19c6026a5085889c$var$Translate(axis, container) {
    const translate = axis.scroll === "x" ? x : y;
    const containerStyle = container.style;
    let disabled = false;
    function x(n) {
        return `translate3d(${n}px,0px,0px)`;
    }
    function y(n) {
        return `translate3d(0px,${n}px,0px)`;
    }
    function to(target) {
        if (disabled) return;
        containerStyle.transform = translate(axis.direction(target));
    }
    function toggleActive(active) {
        disabled = !active;
    }
    function clear() {
        if (disabled) return;
        containerStyle.transform = "";
        if (!container.getAttribute("style")) container.removeAttribute("style");
    }
    const self = {
        clear: clear,
        to: to,
        toggleActive: toggleActive
    };
    return self;
}
function $19c6026a5085889c$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, location, slides) {
    const roundingSafety = 0.5;
    const ascItems = $19c6026a5085889c$var$arrayKeys(slideSizesWithGaps);
    const descItems = $19c6026a5085889c$var$arrayKeys(slideSizesWithGaps).reverse();
    const loopPoints = startPoints().concat(endPoints());
    function removeSlideSizes(indexes, from) {
        return indexes.reduce((a, i)=>{
            return a - slideSizesWithGaps[i];
        }, from);
    }
    function slidesInGap(indexes, gap) {
        return indexes.reduce((a, i)=>{
            const remainingGap = removeSlideSizes(a, gap);
            return remainingGap > 0 ? a.concat([
                i
            ]) : a;
        }, []);
    }
    function findSlideBounds(offset) {
        return snaps.map((snap, index)=>({
                start: snap - slideSizes[index] + roundingSafety + offset,
                end: snap + viewSize - roundingSafety + offset
            }));
    }
    function findLoopPoints(indexes, offset, isEndEdge) {
        const slideBounds = findSlideBounds(offset);
        return indexes.map((index)=>{
            const initial = isEndEdge ? 0 : -contentSize;
            const altered = isEndEdge ? contentSize : 0;
            const boundEdge = isEndEdge ? "end" : "start";
            const loopPoint = slideBounds[index][boundEdge];
            return {
                index: index,
                loopPoint: loopPoint,
                slideLocation: $19c6026a5085889c$var$Vector1D(-1),
                translate: $19c6026a5085889c$var$Translate(axis, slides[index]),
                target: ()=>location.get() > loopPoint ? initial : altered
            };
        });
    }
    function startPoints() {
        const gap = scrollSnaps[0];
        const indexes = slidesInGap(descItems, gap);
        return findLoopPoints(indexes, contentSize, false);
    }
    function endPoints() {
        const gap = viewSize - scrollSnaps[0] - 1;
        const indexes = slidesInGap(ascItems, gap);
        return findLoopPoints(indexes, -contentSize, true);
    }
    function canLoop() {
        return loopPoints.every(({ index: index })=>{
            const otherIndexes = ascItems.filter((i)=>i !== index);
            return removeSlideSizes(otherIndexes, viewSize) <= 0.1;
        });
    }
    function loop() {
        loopPoints.forEach((loopPoint)=>{
            const { target: target, translate: translate, slideLocation: slideLocation } = loopPoint;
            const shiftLocation = target();
            if (shiftLocation === slideLocation.get()) return;
            translate.to(shiftLocation);
            slideLocation.set(shiftLocation);
        });
    }
    function clear() {
        loopPoints.forEach((loopPoint)=>loopPoint.translate.clear());
    }
    const self = {
        canLoop: canLoop,
        clear: clear,
        loop: loop,
        loopPoints: loopPoints
    };
    return self;
}
function $19c6026a5085889c$var$SlidesHandler(container, eventHandler, watchSlides) {
    let mutationObserver;
    let destroyed = false;
    function init(emblaApi) {
        if (!watchSlides) return;
        function defaultCallback(mutations) {
            for (const mutation of mutations)if (mutation.type === "childList") {
                emblaApi.reInit();
                eventHandler.emit("slidesChanged");
                break;
            }
        }
        mutationObserver = new MutationObserver((mutations)=>{
            if (destroyed) return;
            if ($19c6026a5085889c$var$isBoolean(watchSlides) || watchSlides(emblaApi, mutations)) defaultCallback(mutations);
        });
        mutationObserver.observe(container, {
            childList: true
        });
    }
    function destroy() {
        if (mutationObserver) mutationObserver.disconnect();
        destroyed = true;
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $19c6026a5085889c$var$SlidesInView(container, slides, eventHandler, threshold) {
    const intersectionEntryMap = {};
    let inViewCache = null;
    let notInViewCache = null;
    let intersectionObserver;
    let destroyed = false;
    function init() {
        intersectionObserver = new IntersectionObserver((entries)=>{
            if (destroyed) return;
            entries.forEach((entry)=>{
                const index = slides.indexOf(entry.target);
                intersectionEntryMap[index] = entry;
            });
            inViewCache = null;
            notInViewCache = null;
            eventHandler.emit("slidesInView");
        }, {
            root: container.parentElement,
            threshold: threshold
        });
        slides.forEach((slide)=>intersectionObserver.observe(slide));
    }
    function destroy() {
        if (intersectionObserver) intersectionObserver.disconnect();
        destroyed = true;
    }
    function createInViewList(inView) {
        return $19c6026a5085889c$var$objectKeys(intersectionEntryMap).reduce((list, slideIndex)=>{
            const index = parseInt(slideIndex);
            const { isIntersecting: isIntersecting } = intersectionEntryMap[index];
            const inViewMatch = inView && isIntersecting;
            const notInViewMatch = !inView && !isIntersecting;
            if (inViewMatch || notInViewMatch) list.push(index);
            return list;
        }, []);
    }
    function get(inView = true) {
        if (inView && inViewCache) return inViewCache;
        if (!inView && notInViewCache) return notInViewCache;
        const slideIndexes = createInViewList(inView);
        if (inView) inViewCache = slideIndexes;
        if (!inView) notInViewCache = slideIndexes;
        return slideIndexes;
    }
    const self = {
        init: init,
        destroy: destroy,
        get: get
    };
    return self;
}
function $19c6026a5085889c$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow) {
    const { measureSize: measureSize, startEdge: startEdge, endEdge: endEdge } = axis;
    const withEdgeGap = slideRects[0] && readEdgeGap;
    const startGap = measureStartGap();
    const endGap = measureEndGap();
    const slideSizes = slideRects.map(measureSize);
    const slideSizesWithGaps = measureWithGaps();
    function measureStartGap() {
        if (!withEdgeGap) return 0;
        const slideRect = slideRects[0];
        return $19c6026a5085889c$var$mathAbs(containerRect[startEdge] - slideRect[startEdge]);
    }
    function measureEndGap() {
        if (!withEdgeGap) return 0;
        const style = ownerWindow.getComputedStyle($19c6026a5085889c$var$arrayLast(slides));
        return parseFloat(style.getPropertyValue(`margin-${endEdge}`));
    }
    function measureWithGaps() {
        return slideRects.map((rect, index, rects)=>{
            const isFirst = !index;
            const isLast = $19c6026a5085889c$var$arrayIsLastIndex(rects, index);
            if (isFirst) return slideSizes[index] + startGap;
            if (isLast) return slideSizes[index] + endGap;
            return rects[index + 1][startEdge] - rect[startEdge];
        }).map($19c6026a5085889c$var$mathAbs);
    }
    const self = {
        slideSizes: slideSizes,
        slideSizesWithGaps: slideSizesWithGaps,
        startGap: startGap,
        endGap: endGap
    };
    return self;
}
function $19c6026a5085889c$var$SlidesToScroll(axis, viewSize, slidesToScroll, loop, containerRect, slideRects, startGap, endGap, pixelTolerance) {
    const { startEdge: startEdge, endEdge: endEdge, direction: direction } = axis;
    const groupByNumber = $19c6026a5085889c$var$isNumber(slidesToScroll);
    function byNumber(array, groupSize) {
        return $19c6026a5085889c$var$arrayKeys(array).filter((i)=>i % groupSize === 0).map((i)=>array.slice(i, i + groupSize));
    }
    function bySize(array) {
        if (!array.length) return [];
        return $19c6026a5085889c$var$arrayKeys(array).reduce((groups, rectB, index)=>{
            const rectA = $19c6026a5085889c$var$arrayLast(groups) || 0;
            const isFirst = rectA === 0;
            const isLast = rectB === $19c6026a5085889c$var$arrayLastIndex(array);
            const edgeA = containerRect[startEdge] - slideRects[rectA][startEdge];
            const edgeB = containerRect[startEdge] - slideRects[rectB][endEdge];
            const gapA = !loop && isFirst ? direction(startGap) : 0;
            const gapB = !loop && isLast ? direction(endGap) : 0;
            const chunkSize = $19c6026a5085889c$var$mathAbs(edgeB - gapB - (edgeA + gapA));
            if (index && chunkSize > viewSize + pixelTolerance) groups.push(rectB);
            if (isLast) groups.push(array.length);
            return groups;
        }, []).map((currentSize, index, groups)=>{
            const previousSize = Math.max(groups[index - 1] || 0);
            return array.slice(previousSize, currentSize);
        });
    }
    function groupSlides(array) {
        return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
    }
    const self = {
        groupSlides: groupSlides
    };
    return self;
}
function $19c6026a5085889c$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler) {
    // Options
    const { align: align, axis: scrollAxis, direction: direction, startIndex: startIndex, loop: loop, duration: duration, dragFree: dragFree, dragThreshold: dragThreshold, inViewThreshold: inViewThreshold, slidesToScroll: groupSlides, skipSnaps: skipSnaps, containScroll: containScroll, watchResize: watchResize, watchSlides: watchSlides, watchDrag: watchDrag, watchFocus: watchFocus } = options;
    // Measurements
    const pixelTolerance = 2;
    const nodeRects = $19c6026a5085889c$var$NodeRects();
    const containerRect = nodeRects.measure(container);
    const slideRects = slides.map(nodeRects.measure);
    const axis = $19c6026a5085889c$var$Axis(scrollAxis, direction);
    const viewSize = axis.measureSize(containerRect);
    const percentOfView = $19c6026a5085889c$var$PercentOfView(viewSize);
    const alignment = $19c6026a5085889c$var$Alignment(align, viewSize);
    const containSnaps = !loop && !!containScroll;
    const readEdgeGap = loop || !!containScroll;
    const { slideSizes: slideSizes, slideSizesWithGaps: slideSizesWithGaps, startGap: startGap, endGap: endGap } = $19c6026a5085889c$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow);
    const slidesToScroll = $19c6026a5085889c$var$SlidesToScroll(axis, viewSize, groupSlides, loop, containerRect, slideRects, startGap, endGap, pixelTolerance);
    const { snaps: snaps, snapsAligned: snapsAligned } = $19c6026a5085889c$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll);
    const contentSize = -$19c6026a5085889c$var$arrayLast(snaps) + $19c6026a5085889c$var$arrayLast(slideSizesWithGaps);
    const { snapsContained: snapsContained, scrollContainLimit: scrollContainLimit } = $19c6026a5085889c$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance);
    const scrollSnaps = containSnaps ? snapsContained : snapsAligned;
    const { limit: limit } = $19c6026a5085889c$var$ScrollLimit(contentSize, scrollSnaps, loop);
    // Indexes
    const index = $19c6026a5085889c$var$Counter($19c6026a5085889c$var$arrayLastIndex(scrollSnaps), startIndex, loop);
    const indexPrevious = index.clone();
    const slideIndexes = $19c6026a5085889c$var$arrayKeys(slides);
    // Animation
    const update = ({ dragHandler: dragHandler, scrollBody: scrollBody, scrollBounds: scrollBounds, options: { loop: loop } }, timeStep)=>{
        if (!loop) scrollBounds.constrain(dragHandler.pointerDown());
        scrollBody.seek(timeStep);
    };
    const render = ({ scrollBody: scrollBody, translate: translate, location: location, offsetLocation: offsetLocation, scrollLooper: scrollLooper, slideLooper: slideLooper, dragHandler: dragHandler, animation: animation, eventHandler: eventHandler, scrollBounds: scrollBounds, options: { loop: loop } }, lagOffset)=>{
        const shouldSettle = scrollBody.settled();
        const withinBounds = !scrollBounds.shouldConstrain();
        const hasSettled = loop ? shouldSettle : shouldSettle && withinBounds;
        if (hasSettled && !dragHandler.pointerDown()) {
            animation.stop();
            eventHandler.emit("settle");
        }
        if (!hasSettled) eventHandler.emit("scroll");
        const interpolatedLocation = location.get() * lagOffset + previousLocation.get() * (1 - lagOffset);
        offsetLocation.set(interpolatedLocation);
        if (loop) {
            scrollLooper.loop(scrollBody.direction());
            slideLooper.loop();
        }
        translate.to(offsetLocation.get());
    };
    const animation = $19c6026a5085889c$var$Animations(ownerDocument, ownerWindow, (timeStep)=>update(engine, timeStep), (lagOffset)=>render(engine, lagOffset));
    // Shared
    const friction = 0.68;
    const startLocation = scrollSnaps[index.get()];
    const location = $19c6026a5085889c$var$Vector1D(startLocation);
    const previousLocation = $19c6026a5085889c$var$Vector1D(startLocation);
    const offsetLocation = $19c6026a5085889c$var$Vector1D(startLocation);
    const target = $19c6026a5085889c$var$Vector1D(startLocation);
    const scrollBody = $19c6026a5085889c$var$ScrollBody(location, offsetLocation, previousLocation, target, duration, friction);
    const scrollTarget = $19c6026a5085889c$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
    const scrollTo = $19c6026a5085889c$var$ScrollTo(animation, index, indexPrevious, scrollBody, scrollTarget, target, eventHandler);
    const scrollProgress = $19c6026a5085889c$var$ScrollProgress(limit);
    const eventStore = $19c6026a5085889c$var$EventStore();
    const slidesInView = $19c6026a5085889c$var$SlidesInView(container, slides, eventHandler, inViewThreshold);
    const { slideRegistry: slideRegistry } = $19c6026a5085889c$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes);
    const slideFocus = $19c6026a5085889c$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus);
    // Engine
    const engine = {
        ownerDocument: ownerDocument,
        ownerWindow: ownerWindow,
        eventHandler: eventHandler,
        containerRect: containerRect,
        slideRects: slideRects,
        animation: animation,
        axis: axis,
        dragHandler: $19c6026a5085889c$var$DragHandler(axis, root, ownerDocument, ownerWindow, target, $19c6026a5085889c$var$DragTracker(axis, ownerWindow), location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, friction, watchDrag),
        eventStore: eventStore,
        percentOfView: percentOfView,
        index: index,
        indexPrevious: indexPrevious,
        limit: limit,
        location: location,
        offsetLocation: offsetLocation,
        previousLocation: previousLocation,
        options: options,
        resizeHandler: $19c6026a5085889c$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects),
        scrollBody: scrollBody,
        scrollBounds: $19c6026a5085889c$var$ScrollBounds(limit, offsetLocation, target, scrollBody, percentOfView),
        scrollLooper: $19c6026a5085889c$var$ScrollLooper(contentSize, limit, offsetLocation, [
            location,
            offsetLocation,
            previousLocation,
            target
        ]),
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnaps.map(scrollProgress.get),
        scrollSnaps: scrollSnaps,
        scrollTarget: scrollTarget,
        scrollTo: scrollTo,
        slideLooper: $19c6026a5085889c$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides),
        slideFocus: slideFocus,
        slidesHandler: $19c6026a5085889c$var$SlidesHandler(container, eventHandler, watchSlides),
        slidesInView: slidesInView,
        slideIndexes: slideIndexes,
        slideRegistry: slideRegistry,
        slidesToScroll: slidesToScroll,
        target: target,
        translate: $19c6026a5085889c$var$Translate(axis, container)
    };
    return engine;
}
function $19c6026a5085889c$var$EventHandler() {
    let listeners = {};
    let api;
    function init(emblaApi) {
        api = emblaApi;
    }
    function getListeners(evt) {
        return listeners[evt] || [];
    }
    function emit(evt) {
        getListeners(evt).forEach((e)=>e(api, evt));
        return self;
    }
    function on(evt, cb) {
        listeners[evt] = getListeners(evt).concat([
            cb
        ]);
        return self;
    }
    function off(evt, cb) {
        listeners[evt] = getListeners(evt).filter((e)=>e !== cb);
        return self;
    }
    function clear() {
        listeners = {};
    }
    const self = {
        init: init,
        emit: emit,
        off: off,
        on: on,
        clear: clear
    };
    return self;
}
const $19c6026a5085889c$var$defaultOptions = {
    align: "center",
    axis: "x",
    container: null,
    slides: null,
    containScroll: "trimSnaps",
    direction: "ltr",
    slidesToScroll: 1,
    inViewThreshold: 0,
    breakpoints: {},
    dragFree: false,
    dragThreshold: 10,
    loop: false,
    skipSnaps: false,
    duration: 25,
    startIndex: 0,
    active: true,
    watchDrag: true,
    watchResize: true,
    watchSlides: true,
    watchFocus: true
};
function $19c6026a5085889c$var$OptionsHandler(ownerWindow) {
    function mergeOptions(optionsA, optionsB) {
        return $19c6026a5085889c$var$objectsMergeDeep(optionsA, optionsB || {});
    }
    function optionsAtMedia(options) {
        const optionsAtMedia = options.breakpoints || {};
        const matchedMediaOptions = $19c6026a5085889c$var$objectKeys(optionsAtMedia).filter((media)=>ownerWindow.matchMedia(media).matches).map((media)=>optionsAtMedia[media]).reduce((a, mediaOption)=>mergeOptions(a, mediaOption), {});
        return mergeOptions(options, matchedMediaOptions);
    }
    function optionsMediaQueries(optionsList) {
        return optionsList.map((options)=>$19c6026a5085889c$var$objectKeys(options.breakpoints || {})).reduce((acc, mediaQueries)=>acc.concat(mediaQueries), []).map(ownerWindow.matchMedia);
    }
    const self = {
        mergeOptions: mergeOptions,
        optionsAtMedia: optionsAtMedia,
        optionsMediaQueries: optionsMediaQueries
    };
    return self;
}
function $19c6026a5085889c$var$PluginsHandler(optionsHandler) {
    let activePlugins = [];
    function init(emblaApi, plugins) {
        activePlugins = plugins.filter(({ options: options })=>optionsHandler.optionsAtMedia(options).active !== false);
        activePlugins.forEach((plugin)=>plugin.init(emblaApi, optionsHandler));
        return plugins.reduce((map, plugin)=>Object.assign(map, {
                [plugin.name]: plugin
            }), {});
    }
    function destroy() {
        activePlugins = activePlugins.filter((plugin)=>plugin.destroy());
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $19c6026a5085889c$export$2e2bcd8739ae039(root, userOptions, userPlugins) {
    const ownerDocument = root.ownerDocument;
    const ownerWindow = ownerDocument.defaultView;
    const optionsHandler = $19c6026a5085889c$var$OptionsHandler(ownerWindow);
    const pluginsHandler = $19c6026a5085889c$var$PluginsHandler(optionsHandler);
    const mediaHandlers = $19c6026a5085889c$var$EventStore();
    const eventHandler = $19c6026a5085889c$var$EventHandler();
    const { mergeOptions: mergeOptions, optionsAtMedia: optionsAtMedia, optionsMediaQueries: optionsMediaQueries } = optionsHandler;
    const { on: on, off: off, emit: emit } = eventHandler;
    const reInit = reActivate;
    let destroyed = false;
    let engine;
    let optionsBase = mergeOptions($19c6026a5085889c$var$defaultOptions, $19c6026a5085889c$export$2e2bcd8739ae039.globalOptions);
    let options = mergeOptions(optionsBase);
    let pluginList = [];
    let pluginApis;
    let container;
    let slides;
    function storeElements() {
        const { container: userContainer, slides: userSlides } = options;
        const customContainer = $19c6026a5085889c$var$isString(userContainer) ? root.querySelector(userContainer) : userContainer;
        container = customContainer || root.children[0];
        const customSlides = $19c6026a5085889c$var$isString(userSlides) ? container.querySelectorAll(userSlides) : userSlides;
        slides = [].slice.call(customSlides || container.children);
    }
    function createEngine(options) {
        const engine = $19c6026a5085889c$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler);
        if (options.loop && !engine.slideLooper.canLoop()) {
            const optionsWithoutLoop = Object.assign({}, options, {
                loop: false
            });
            return createEngine(optionsWithoutLoop);
        }
        return engine;
    }
    function activate(withOptions, withPlugins) {
        if (destroyed) return;
        optionsBase = mergeOptions(optionsBase, withOptions);
        options = optionsAtMedia(optionsBase);
        pluginList = withPlugins || pluginList;
        storeElements();
        engine = createEngine(options);
        optionsMediaQueries([
            optionsBase,
            ...pluginList.map(({ options: options })=>options)
        ]).forEach((query)=>mediaHandlers.add(query, "change", reActivate));
        if (!options.active) return;
        engine.translate.to(engine.location.get());
        engine.animation.init();
        engine.slidesInView.init();
        engine.slideFocus.init(self);
        engine.eventHandler.init(self);
        engine.resizeHandler.init(self);
        engine.slidesHandler.init(self);
        if (engine.options.loop) engine.slideLooper.loop();
        if (container.offsetParent && slides.length) engine.dragHandler.init(self);
        pluginApis = pluginsHandler.init(self, pluginList);
    }
    function reActivate(withOptions, withPlugins) {
        const startIndex = selectedScrollSnap();
        deActivate();
        activate(mergeOptions({
            startIndex: startIndex
        }, withOptions), withPlugins);
        eventHandler.emit("reInit");
    }
    function deActivate() {
        engine.dragHandler.destroy();
        engine.eventStore.clear();
        engine.translate.clear();
        engine.slideLooper.clear();
        engine.resizeHandler.destroy();
        engine.slidesHandler.destroy();
        engine.slidesInView.destroy();
        engine.animation.destroy();
        pluginsHandler.destroy();
        mediaHandlers.clear();
    }
    function destroy() {
        if (destroyed) return;
        destroyed = true;
        mediaHandlers.clear();
        deActivate();
        eventHandler.emit("destroy");
        eventHandler.clear();
    }
    function scrollTo(index, jump, direction) {
        if (!options.active || destroyed) return;
        engine.scrollBody.useBaseFriction().useDuration(jump === true ? 0 : options.duration);
        engine.scrollTo.index(index, direction || 0);
    }
    function scrollNext(jump) {
        const next = engine.index.add(1).get();
        scrollTo(next, jump, -1);
    }
    function scrollPrev(jump) {
        const prev = engine.index.add(-1).get();
        scrollTo(prev, jump, 1);
    }
    function canScrollNext() {
        const next = engine.index.add(1).get();
        return next !== selectedScrollSnap();
    }
    function canScrollPrev() {
        const prev = engine.index.add(-1).get();
        return prev !== selectedScrollSnap();
    }
    function scrollSnapList() {
        return engine.scrollSnapList;
    }
    function scrollProgress() {
        return engine.scrollProgress.get(engine.location.get());
    }
    function selectedScrollSnap() {
        return engine.index.get();
    }
    function previousScrollSnap() {
        return engine.indexPrevious.get();
    }
    function slidesInView() {
        return engine.slidesInView.get();
    }
    function slidesNotInView() {
        return engine.slidesInView.get(false);
    }
    function plugins() {
        return pluginApis;
    }
    function internalEngine() {
        return engine;
    }
    function rootNode() {
        return root;
    }
    function containerNode() {
        return container;
    }
    function slideNodes() {
        return slides;
    }
    const self = {
        canScrollNext: canScrollNext,
        canScrollPrev: canScrollPrev,
        containerNode: containerNode,
        internalEngine: internalEngine,
        destroy: destroy,
        off: off,
        on: on,
        emit: emit,
        plugins: plugins,
        previousScrollSnap: previousScrollSnap,
        reInit: reInit,
        rootNode: rootNode,
        scrollNext: scrollNext,
        scrollPrev: scrollPrev,
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnapList,
        scrollTo: scrollTo,
        selectedScrollSnap: selectedScrollSnap,
        slideNodes: slideNodes,
        slidesInView: slidesInView,
        slidesNotInView: slidesNotInView
    };
    activate(userOptions, userPlugins);
    setTimeout(()=>eventHandler.emit("init"), 0);
    return self;
}
$19c6026a5085889c$export$2e2bcd8739ae039.globalOptions = undefined;


const $a4b2d0cb7ef3861a$var$defaultOptions = {
    active: true,
    breakpoints: {},
    delay: 4000,
    jump: false,
    playOnInit: true,
    stopOnFocusIn: true,
    stopOnInteraction: true,
    stopOnMouseEnter: false,
    stopOnLastSnap: false,
    rootNode: null
};
function $a4b2d0cb7ef3861a$export$2e2bcd8739ae039(userOptions = {}) {
    let options;
    let emblaApi;
    let destroyed;
    let playing = false;
    let resume = true;
    let jump = false;
    let timer = 0;
    function init(emblaApiInstance, optionsHandler) {
        emblaApi = emblaApiInstance;
        const { mergeOptions: mergeOptions, optionsAtMedia: optionsAtMedia } = optionsHandler;
        const optionsBase = mergeOptions($a4b2d0cb7ef3861a$var$defaultOptions, $a4b2d0cb7ef3861a$export$2e2bcd8739ae039.globalOptions);
        const allOptions = mergeOptions(optionsBase, userOptions);
        options = optionsAtMedia(allOptions);
        if (emblaApi.scrollSnapList().length <= 1) return;
        jump = options.jump;
        destroyed = false;
        const { eventStore: eventStore, ownerDocument: ownerDocument } = emblaApi.internalEngine();
        const emblaRoot = emblaApi.rootNode();
        const root = options.rootNode && options.rootNode(emblaRoot) || emblaRoot;
        const container = emblaApi.containerNode();
        emblaApi.on("pointerDown", stopTimer);
        if (!options.stopOnInteraction) emblaApi.on("pointerUp", startTimer);
        if (options.stopOnMouseEnter) {
            eventStore.add(root, "mouseenter", ()=>{
                resume = false;
                stopTimer();
            });
            if (!options.stopOnInteraction) eventStore.add(root, "mouseleave", ()=>{
                resume = true;
                startTimer();
            });
        }
        if (options.stopOnFocusIn) {
            emblaApi.on("slideFocusStart", stopTimer);
            if (!options.stopOnInteraction) eventStore.add(container, "focusout", startTimer);
        }
        eventStore.add(ownerDocument, "visibilitychange", visibilityChange);
        if (options.playOnInit && !documentIsHidden()) startTimer();
    }
    function destroy() {
        emblaApi.off("pointerDown", stopTimer).off("pointerUp", startTimer).off("slideFocusStart", stopTimer);
        stopTimer();
        destroyed = true;
        playing = false;
    }
    function startTimer() {
        if (destroyed) return;
        if (!resume) return;
        if (!playing) emblaApi.emit("autoplay:play");
        const { ownerWindow: ownerWindow } = emblaApi.internalEngine();
        ownerWindow.clearInterval(timer);
        timer = ownerWindow.setInterval(next, options.delay);
        playing = true;
    }
    function stopTimer() {
        if (destroyed) return;
        if (playing) emblaApi.emit("autoplay:stop");
        const { ownerWindow: ownerWindow } = emblaApi.internalEngine();
        ownerWindow.clearInterval(timer);
        timer = 0;
        playing = false;
    }
    function visibilityChange() {
        if (documentIsHidden()) {
            resume = playing;
            return stopTimer();
        }
        if (resume) startTimer();
    }
    function documentIsHidden() {
        const { ownerDocument: ownerDocument } = emblaApi.internalEngine();
        return ownerDocument.visibilityState === "hidden";
    }
    function play(jumpOverride) {
        if (typeof jumpOverride !== "undefined") jump = jumpOverride;
        resume = true;
        startTimer();
    }
    function stop() {
        if (playing) stopTimer();
    }
    function reset() {
        if (playing) play();
    }
    function isPlaying() {
        return playing;
    }
    function next() {
        const { index: index } = emblaApi.internalEngine();
        const nextIndex = index.clone().add(1).get();
        const lastIndex = emblaApi.scrollSnapList().length - 1;
        const kill = options.stopOnLastSnap && nextIndex === lastIndex;
        if (kill) stopTimer();
        if (emblaApi.canScrollNext()) emblaApi.scrollNext(jump);
        else emblaApi.scrollTo(0, jump);
    }
    const self = {
        name: "autoplay",
        options: userOptions,
        init: init,
        destroy: destroy,
        play: play,
        stop: stop,
        reset: reset,
        isPlaying: isPlaying
    };
    return self;
}
$a4b2d0cb7ef3861a$export$2e2bcd8739ae039.globalOptions = undefined;


const $f14a90128e90d51e$export$604ab292679fc001 = (emblaApi, prevBtn, nextBtn)=>{
    const scrollPrev = ()=>emblaApi.scrollPrev();
    const scrollNext = ()=>emblaApi.scrollNext();
    prevBtn.addEventListener("click", scrollPrev, false);
    nextBtn.addEventListener("click", scrollNext, false);
    return ()=>{
        prevBtn.removeEventListener("click", scrollPrev, false);
        nextBtn.removeEventListener("click", scrollNext, false);
    };
};
const $f14a90128e90d51e$export$a607f631c2d9f935 = (emblaApi, prevBtn, nextBtn)=>{
    const togglePrevNextBtnsState = ()=>{
        if (emblaApi.canScrollPrev()) prevBtn.removeAttribute("disabled");
        else prevBtn.setAttribute("disabled", "disabled");
        if (emblaApi.canScrollNext()) nextBtn.removeAttribute("disabled");
        else nextBtn.setAttribute("disabled", "disabled");
    };
    emblaApi.on("select", togglePrevNextBtnsState).on("init", togglePrevNextBtnsState).on("reInit", togglePrevNextBtnsState);
    return ()=>{
        prevBtn.removeAttribute("disabled");
        nextBtn.setAttribute("disabled", "disabled");
    };
};
const $f14a90128e90d51e$export$facf7ea5340ed01e = (emblaApi, dotsNode)=>{
    let dotNodes = [];
    const addDotBtnsWithClickHandlers = ()=>{
        dotsNode.innerHTML = emblaApi.scrollSnapList().map(()=>'<button aria-label="carousel pagination button" class="embla__dot" type="button"></button>').join("");
        dotNodes = Array.from(dotsNode.querySelectorAll(".embla__dot"));
        dotNodes.forEach((dotNode, index)=>{
            dotNode.addEventListener("click", ()=>emblaApi.scrollTo(index), false);
        });
    };
    const toggleDotBtnsActive = ()=>{
        const previous = emblaApi.previousScrollSnap();
        const selected = emblaApi.selectedScrollSnap();
        dotNodes[previous].classList.remove("embla__dot--selected");
        dotNodes[selected].classList.add("embla__dot--selected");
    };
    emblaApi.on("init", addDotBtnsWithClickHandlers).on("reInit", addDotBtnsWithClickHandlers).on("init", toggleDotBtnsActive).on("reInit", toggleDotBtnsActive).on("select", toggleDotBtnsActive);
    return ()=>{
        dotsNode.innerHTML = "";
    };
};
const $f14a90128e90d51e$export$772a48efac908d10 = (emblaApiMain, emblaApiThumb)=>{
    const slidesThumbs = emblaApiThumb.slideNodes();
    const scrollToIndex = slidesThumbs.map((_, index)=>()=>emblaApiMain.scrollTo(index));
    slidesThumbs.forEach((slideNode, index)=>{
        slideNode.addEventListener("click", scrollToIndex[index], false);
    });
    return ()=>{
        slidesThumbs.forEach((slideNode, index)=>{
            slideNode.removeEventListener("click", scrollToIndex[index], false);
        });
    };
};
const $f14a90128e90d51e$export$a3ace2c6bbe4b6cd = (emblaApiMain, emblaApiThumb)=>{
    const slidesThumbs = emblaApiThumb.slideNodes();
    const toggleThumbBtnsState = ()=>{
        emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap());
        const previous = emblaApiMain.previousScrollSnap();
        const selected = emblaApiMain.selectedScrollSnap();
        slidesThumbs[previous].classList.remove("embla-thumbs__slide--selected");
        slidesThumbs[selected].classList.add("embla-thumbs__slide--selected");
    };
    emblaApiMain.on("select", toggleThumbBtnsState);
    emblaApiThumb.on("init", toggleThumbBtnsState);
    return ()=>{
        const selected = emblaApiMain.selectedScrollSnap();
        slidesThumbs[selected].classList.remove("embla-thumbs__slide--selected");
    };
};
const $f14a90128e90d51e$export$6ab6edc6a63493da = (emblaApi, progressNode)=>{
    const applyProgress = ()=>{
        const progress = Math.max(0, Math.min(1, emblaApi.scrollProgress()));
        progressNode.style.transform = `translate3d(${progress * 100}%,0px,0px)`;
    };
    const removeProgress = ()=>{
        progressNode.removeAttribute("style");
    };
    return {
        applyProgress: applyProgress,
        removeProgress: removeProgress
    };
};


class $ceb1f2482ae53e9e$var$EmblaComponent extends HTMLElement {
    constructor(){
        super();
        this.emblaApi;
        this.emblaApiThumbs;
        this.emblaNode = this.querySelector(".embla");
        this.emblaThumbs = this.querySelector(".embla-thumbs");
        this.viewportNode = this.querySelector(".embla__viewport");
        this.viewportNodeThumbs = this.querySelector(".embla-thumbs__viewport");
        this.prevBtn = this.querySelector(".embla__button--prev");
        this.nextBtn = this.querySelector(".embla__button--next");
        this.dotsNode = this.querySelector(".embla__dots");
        this.options = this.returnConfig();
        this.optionsThumbs = this.returnThumbsConfig();
        this.activeSlide = this.querySelector(".embla__slide");
        this.progressNode = this.querySelector(".embla__progress__bar");
        document.addEventListener("DOMContentLoaded", (e)=>{
            this.extraSlideEls = this.querySelector("embla-extra-slide-els");
            this.initEmbla();
            this.emblaApi.on("select", ()=>this.handleSelect());
            if (this.progressNode) {
                this.emblaApi.on("init", ()=>this.applyProgress());
                this.emblaApi.on("reInit", ()=>this.applyProgress());
                this.emblaApi.on("scroll", ()=>this.applyProgress());
                this.emblaApi.on("destor", ()=>this.removeProgress());
            }
            this.handleActiveSlide();
        });
    }
    initEmbla() {
        this.emblaSlides = this.querySelectorAll(".embla__slide");
        this.emblaApi = (0, $19c6026a5085889c$export$2e2bcd8739ae039)(this.viewportNode, this.options, this.emblaNode.getAttribute("data-autoplay") === "true" ? [
            (0, $a4b2d0cb7ef3861a$export$2e2bcd8739ae039)(this.returnAutoplayConfig())
        ] : null);
        if (this.viewportNodeThumbs) this.emblaApiThumbs = (0, $19c6026a5085889c$export$2e2bcd8739ae039)(this.viewportNodeThumbs, this.optionsThumbs);
        if (this.prevBtn && this.nextBtn) {
            (0, $f14a90128e90d51e$export$604ab292679fc001)(this.emblaApi, this.prevBtn, this.nextBtn);
            (0, $f14a90128e90d51e$export$a607f631c2d9f935)(this.emblaApi, this.prevBtn, this.nextBtn);
        }
        if (this.dotsNode) (0, $f14a90128e90d51e$export$facf7ea5340ed01e)(this.emblaApi, this.dotsNode);
        if (this.progressNode) {
            const { applyProgress: applyProgress, removeProgress: removeProgress } = (0, $f14a90128e90d51e$export$6ab6edc6a63493da)(this.emblaApi, this.progressNode);
            this.applyProgress = applyProgress;
            this.removeProgress = removeProgress;
        }
        if (this.emblaApiThumbs) {
            (0, $f14a90128e90d51e$export$772a48efac908d10)(this.emblaApi, this.emblaApiThumbs);
            (0, $f14a90128e90d51e$export$a3ace2c6bbe4b6cd)(this.emblaApi, this.emblaApiThumbs);
            if (this.emblaThumbs.getAttribute("data-change-slides-on-hover") === "true") {
                const thumbSlides = this.querySelectorAll(".embla-thumbs__slide");
                if (thumbSlides.length > 0) {
                    thumbSlides.forEach((slide)=>{
                        slide.addEventListener("mouseenter", (e)=>{
                            if (this.emblaSlides.length > 1) this.emblaApi.scrollTo(+slide.getAttribute("data-thumb-index"));
                            else {
                                // if only one slide exists, run custom logic to handle extra elements/thumbnails
                                this.extraSlideEls.showExtraSlideEl(slide.getAttribute("data-thumb-index"));
                                thumbSlides.forEach((slide)=>slide.classList.remove("embla-thumbs__slide--selected"));
                                slide.classList.add("embla-thumbs__slide--selected");
                            }
                        });
                    });
                    // if only one slide exists, run custom logic to handle click on extra elements/thumbnails
                    if (this.emblaSlides.length < 2) thumbSlides.forEach((slide)=>{
                        slide.addEventListener("click", (e)=>{
                            this.extraSlideEls.showExtraSlideEl(slide.getAttribute("data-thumb-index"));
                            thumbSlides.forEach((slide)=>slide.classList.remove("embla-thumbs__slide--selected"));
                            slide.classList.add("embla-thumbs__slide--selected");
                        });
                    });
                }
            }
        }
    }
    returnConfig() {
        return {
            breakpoints: {
                "(min-width: 989px)": {
                    active: this.emblaNode.getAttribute("data-mobile-only") == "true" ? false : true
                }
            },
            align: this.emblaNode.getAttribute("data-align") || "center",
            loop: this.emblaNode.getAttribute("data-loop") === "true" ? true : false,
            slidesToScroll: +this.emblaNode.getAttribute("data-slides-to-scroll") || "auto",
            startIndex: +this.emblaNode.getAttribute("data-start-index") || 0,
            containScroll: "trimSnaps",
            axis: this.emblaNode.getAttribute("data-axis") || "x",
            duration: +this.emblaNode.getAttribute("data-duration") || 25,
            slides: this.emblaNode.getAttribute("data-custom-class") || ".embla__slide",
            inViewThreshold: 1
        };
    }
    returnAutoplayConfig() {
        return {
            delay: +this.emblaNode.getAttribute("data-autoplay-speed") || 4000
        };
    }
    returnThumbsConfig() {
        return {
            containScroll: "keepSnaps",
            dragFree: true,
            loop: this.emblaThumbs?.getAttribute("data-thumbs-loop") === "true" ? true : false,
            loop: true
        };
    }
    handleSelect() {
        const activeThumb = this.querySelector(".embla-thumbs__slide--selected");
        if (!activeThumb) return;
        const activeThumbIndex = activeThumb.getAttribute("data-thumb-index");
        this.handleActiveSlide(this.querySelector(`.embla__slide[data-slide-index="${activeThumbIndex}"]`));
        if (this.extraSlideEls) this.extraSlideEls.showExtraSlideEl(activeThumbIndex);
    }
    handleActiveSlide(newSlide) {
        if (newSlide) {
            this.activeSlide.classList.remove("embla__slide--active");
            this.activeSlide = newSlide;
            this.activeSlide.classList.add("embla__slide--active");
        } else if (this.activeSlide) this.activeSlide.classList.add("embla__slide--active");
    }
    goToStart() {
        this.emblaApi.scrollTo(0);
    }
    restart() {
        this.initEmbla();
    }
}
customElements.define("embla-component", $ceb1f2482ae53e9e$var$EmblaComponent);


class $17cbbfd44e7a39a4$var$cardCarouselFilters extends HTMLElement {
    constructor(){
        super();
        this.embla = this.querySelector("embla-component");
        this.tags = this.querySelectorAll(".card-carousel-tag-js");
        this.cards = this.querySelectorAll(".card-carousel-js");
        if (this.tags.length > 0) this.tags.forEach((tag)=>{
            tag.addEventListener("click", (e)=>this.handleCardsToggle(e.target));
        });
    }
    handleCardsToggle(clickedTag) {
        const currentType = clickedTag.getAttribute("data-type");
        if (!currentType || !this.embla) return;
        this.tags.forEach((tag)=>tag.classList.remove("button--tertiary--active"));
        clickedTag.classList.add("button--tertiary--active");
        this.cards = this.querySelectorAll(".card-carousel-js");
        this.cards.forEach((card)=>{
            if (card.getAttribute("data-type") === currentType) {
                card.classList.remove("card--hidden");
                card.classList.add("card--visible");
            } else {
                card.classList.remove("card--visible");
                card.classList.add("card--hidden");
            }
        });
        this.embla.goToStart();
    }
}
customElements.define("card-carousel-filters", $17cbbfd44e7a39a4$var$cardCarouselFilters);


const $bd34b27e78603290$var$headerCl = {
    headerWrapper: "header-sticky-js",
    headerWrapperHidden: "header-sticky-hidden-js",
    headerWrapperSticky: "header-sticky-visible-js"
};
let $bd34b27e78603290$var$previousPosition = 0;
const $bd34b27e78603290$var$determineScrollPosition = function(headerWrapper) {
    const currentPosition = window.scrollY;
    if (currentPosition > $bd34b27e78603290$var$previousPosition) {
        headerWrapper.classList.remove($bd34b27e78603290$var$headerCl.headerWrapperSticky);
        $bd34b27e78603290$var$previousPosition = currentPosition;
    } else {
        headerWrapper.classList.add($bd34b27e78603290$var$headerCl.headerWrapperSticky);
        $bd34b27e78603290$var$previousPosition = currentPosition;
    }
};
function $bd34b27e78603290$export$2e2bcd8739ae039() {
    const headerStickyEl = document.querySelector("." + $bd34b27e78603290$var$headerCl.headerWrapper);
    let headerStickyElHeight;
    window.addEventListener("load", ()=>{
        headerStickyElHeight = headerStickyEl.getBoundingClientRect().height;
        headerStickyEl.parentElement.style.paddingTop = headerStickyElHeight + "px";
        headerStickyEl.style.position = "fixed";
        document.querySelector("#clear-all").setAttribute("data-padding", headerStickyElHeight + "px");
    });
    let scrollRunning = false;
    document.addEventListener("scroll", ()=>{
        if (scrollRunning) return;
        scrollRunning = true;
        setTimeout(()=>{
            if (window.scrollY > headerStickyElHeight * 1.2) {
                headerStickyEl.classList.add($bd34b27e78603290$var$headerCl.headerWrapperHidden);
                $bd34b27e78603290$var$determineScrollPosition(headerStickyEl);
            } else headerStickyEl.classList.remove($bd34b27e78603290$var$headerCl.headerWrapperHidden);
            scrollRunning = false;
        }, 100);
    });
    let resizeRunning = false;
    window.addEventListener("resize", ()=>{
        if (resizeRunning) return;
        resizeRunning = true;
        setTimeout(()=>{
            headerStickyElHeight = headerStickyEl.getBoundingClientRect().height;
            headerStickyEl.parentElement.style.paddingTop = headerStickyElHeight + "px";
            // document.querySelector('#clear-all').setAttribute('data-padding',  headerStickyElHeight + "px");
            resizeRunning = false;
        }, 200);
    });
}


/**
 * Component: Accordion
 * ------------------------------------------------------------------------------
 * ARIA accessible accordion to show/hide content in a tabbed layout.
 *
 * @namespace accordion
 */ /**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $acdc05c5163a1397$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $acdc05c5163a1397$export$2e2bcd8739ae039 = $acdc05c5163a1397$var$isObject;


/** Detect free variable `global` from Node.js. */ var $f516b7844ec12b2d$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $f516b7844ec12b2d$export$2e2bcd8739ae039 = $f516b7844ec12b2d$var$freeGlobal;


/** Detect free variable `self`. */ var $70d87f490d314e55$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $70d87f490d314e55$var$root = (0, $f516b7844ec12b2d$export$2e2bcd8739ae039) || $70d87f490d314e55$var$freeSelf || Function("return this")();
var $70d87f490d314e55$export$2e2bcd8739ae039 = $70d87f490d314e55$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $076958148d7b8c97$var$now = function() {
    return (0, $70d87f490d314e55$export$2e2bcd8739ae039).Date.now();
};
var $076958148d7b8c97$export$2e2bcd8739ae039 = $076958148d7b8c97$var$now;


/** Used to match a single whitespace character. */ var $938b3fb2c8835b92$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $938b3fb2c8835b92$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $938b3fb2c8835b92$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $938b3fb2c8835b92$export$2e2bcd8739ae039 = $938b3fb2c8835b92$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $944ef78c7936f824$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $944ef78c7936f824$var$baseTrim(string) {
    return string ? string.slice(0, (0, $938b3fb2c8835b92$export$2e2bcd8739ae039)(string) + 1).replace($944ef78c7936f824$var$reTrimStart, "") : string;
}
var $944ef78c7936f824$export$2e2bcd8739ae039 = $944ef78c7936f824$var$baseTrim;




/** Built-in value references. */ var $7231ea9a53162d12$var$Symbol = (0, $70d87f490d314e55$export$2e2bcd8739ae039).Symbol;
var $7231ea9a53162d12$export$2e2bcd8739ae039 = $7231ea9a53162d12$var$Symbol;



/** Used for built-in method references. */ var $d45ee1b4ca58b2c4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d45ee1b4ca58b2c4$var$hasOwnProperty = $d45ee1b4ca58b2c4$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d45ee1b4ca58b2c4$var$nativeObjectToString = $d45ee1b4ca58b2c4$var$objectProto.toString;
/** Built-in value references. */ var $d45ee1b4ca58b2c4$var$symToStringTag = (0, $7231ea9a53162d12$export$2e2bcd8739ae039) ? (0, $7231ea9a53162d12$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $d45ee1b4ca58b2c4$var$getRawTag(value) {
    var isOwn = $d45ee1b4ca58b2c4$var$hasOwnProperty.call(value, $d45ee1b4ca58b2c4$var$symToStringTag), tag = value[$d45ee1b4ca58b2c4$var$symToStringTag];
    try {
        value[$d45ee1b4ca58b2c4$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $d45ee1b4ca58b2c4$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$d45ee1b4ca58b2c4$var$symToStringTag] = tag;
        else delete value[$d45ee1b4ca58b2c4$var$symToStringTag];
    }
    return result;
}
var $d45ee1b4ca58b2c4$export$2e2bcd8739ae039 = $d45ee1b4ca58b2c4$var$getRawTag;


/** Used for built-in method references. */ var $d7c9274132d41268$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d7c9274132d41268$var$nativeObjectToString = $d7c9274132d41268$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $d7c9274132d41268$var$objectToString(value) {
    return $d7c9274132d41268$var$nativeObjectToString.call(value);
}
var $d7c9274132d41268$export$2e2bcd8739ae039 = $d7c9274132d41268$var$objectToString;


/** `Object#toString` result references. */ var $10a1a04468b07e88$var$nullTag = "[object Null]", $10a1a04468b07e88$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $10a1a04468b07e88$var$symToStringTag = (0, $7231ea9a53162d12$export$2e2bcd8739ae039) ? (0, $7231ea9a53162d12$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $10a1a04468b07e88$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $10a1a04468b07e88$var$undefinedTag : $10a1a04468b07e88$var$nullTag;
    return $10a1a04468b07e88$var$symToStringTag && $10a1a04468b07e88$var$symToStringTag in Object(value) ? (0, $d45ee1b4ca58b2c4$export$2e2bcd8739ae039)(value) : (0, $d7c9274132d41268$export$2e2bcd8739ae039)(value);
}
var $10a1a04468b07e88$export$2e2bcd8739ae039 = $10a1a04468b07e88$var$baseGetTag;


/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $aa1aa81ff5fe30da$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $aa1aa81ff5fe30da$export$2e2bcd8739ae039 = $aa1aa81ff5fe30da$var$isObjectLike;


/** `Object#toString` result references. */ var $dba9a50b57c13df5$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $dba9a50b57c13df5$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $aa1aa81ff5fe30da$export$2e2bcd8739ae039)(value) && (0, $10a1a04468b07e88$export$2e2bcd8739ae039)(value) == $dba9a50b57c13df5$var$symbolTag;
}
var $dba9a50b57c13df5$export$2e2bcd8739ae039 = $dba9a50b57c13df5$var$isSymbol;


/** Used as references for various `Number` constants. */ var $6c48dfe9f74903d4$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $6c48dfe9f74903d4$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $6c48dfe9f74903d4$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $6c48dfe9f74903d4$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $6c48dfe9f74903d4$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $6c48dfe9f74903d4$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ((0, $dba9a50b57c13df5$export$2e2bcd8739ae039)(value)) return $6c48dfe9f74903d4$var$NAN;
    if ((0, $acdc05c5163a1397$export$2e2bcd8739ae039)(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = (0, $acdc05c5163a1397$export$2e2bcd8739ae039)(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = (0, $944ef78c7936f824$export$2e2bcd8739ae039)(value);
    var isBinary = $6c48dfe9f74903d4$var$reIsBinary.test(value);
    return isBinary || $6c48dfe9f74903d4$var$reIsOctal.test(value) ? $6c48dfe9f74903d4$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $6c48dfe9f74903d4$var$reIsBadHex.test(value) ? $6c48dfe9f74903d4$var$NAN : +value;
}
var $6c48dfe9f74903d4$export$2e2bcd8739ae039 = $6c48dfe9f74903d4$var$toNumber;


/** Error message constants. */ var $66225070125f262f$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $66225070125f262f$var$nativeMax = Math.max, $66225070125f262f$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $66225070125f262f$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($66225070125f262f$var$FUNC_ERROR_TEXT);
    wait = (0, $6c48dfe9f74903d4$export$2e2bcd8739ae039)(wait) || 0;
    if ((0, $acdc05c5163a1397$export$2e2bcd8739ae039)(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $66225070125f262f$var$nativeMax((0, $6c48dfe9f74903d4$export$2e2bcd8739ae039)(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $66225070125f262f$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $076958148d7b8c97$export$2e2bcd8739ae039)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $076958148d7b8c97$export$2e2bcd8739ae039)());
    }
    function debounced() {
        var time = (0, $076958148d7b8c97$export$2e2bcd8739ae039)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $66225070125f262f$export$2e2bcd8739ae039 = $66225070125f262f$var$debounce;


/**
 * Helper: CSS classes
 * -----------------------------------------------------------------------------
 * Global configuration for css classes.
 * - Used to provide consistency and keep DRY for our toggle classes.
 */ var $4da88745b4eecfc5$export$2e2bcd8739ae039 = {
    active: "is-active",
    adding: "is-adding",
    added: "is-added",
    collapsed: "is-collapsed",
    disabled: "is-disabled",
    focused: "is-focused",
    hidden: "is-hidden",
    loaded: "is-loaded",
    loading: "is-loading",
    locked: "is-locked",
    removing: "is-removing",
    sticky: "is-sticky",
    transitioning: "is-transitioning",
    headerClear: "site-header--transparent"
};


/**
 * Helper: Utils
 * ------------------------------------------------------------------------------
 * Karmoon utility functions.
 *
 * @namespace utils
 */ /**
 * Get unique objects from object literal.
 * @param {Object} object - Array/Object to remove duplicates from.
 * @returns {Object}
 */ function $54b4d535c8b4d410$export$7a5d5c156e7dc406(object) {
    return object.filter((value, index, self)=>self.indexOf(value) === index);
}
function $54b4d535c8b4d410$export$acaf96a27438246b(array1, array2) {
    return array1.concat(array2).filter((value, index, self)=>{
        return self.indexOf(value) === self.lastIndexOf(value);
    });
}
function $54b4d535c8b4d410$export$c72c4b7feb522769(defaults, properties) {
    // eslint-disable-next-line no-restricted-syntax
    for(const property in properties)if (properties != null && typeof properties !== "undefined") defaults[property] = properties[property];
    return defaults;
}
function $54b4d535c8b4d410$export$f312c3733b79ac0d(element) {
    return Array.prototype.filter.call(element.parentNode.children, (sibling)=>{
        return sibling !== element;
    });
}
function $54b4d535c8b4d410$export$dfdc1655ccc5b9cb(form) {
    const serialized = [];
    /**
     * Loop through each field in the form.
     */ // eslint-disable-next-line no-plusplus
    for(let i = 0; i < form.elements.length; i++){
        const field = form.elements[i];
        // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
        if (!field.name || field.disabled || field.type === "file" || field.type === "reset" || field.type === "submit" || field.type === "button") continue;
        /**
       * If a multi-select, get all selections.
       */ if (field.type === "select-multiple") // eslint-disable-next-line no-plusplus
        for(let counter = 0; counter < field.options.length; counter++){
            if (!field.options[counter].selected) continue;
            serialized.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(field.options[counter].value)}`);
        }
        else if (field.type !== "checkbox" && field.type !== "radio" || field.checked) serialized.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`);
    }
    return serialized.join("&");
}
function $54b4d535c8b4d410$export$af631764ddc44097(event, elem = window, callback, capture = false) {
    /**
     * If only a string is passed into the element parameter.
     */ if (typeof elem === "string") {
        document.querySelector(elem).addEventListener(event, callback, capture);
        return;
    }
    /**
     * If an element is not defined in parameters, then shift callback across.
     */ if (typeof elem === "function") {
        window.addEventListener(event, elem);
        return;
    }
    /**
     * Default listener.
     */ elem.addEventListener(event, callback, capture);
}
function $54b4d535c8b4d410$export$89e15fc796a4a429() {
    const { userAgent: userAgent } = window.navigator;
    // The order matters here, and this may report false positives for unlisted browsers.
    if (userAgent.indexOf("Firefox") > -1) // 'Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0'
    return "Firefox";
    if (userAgent.indexOf("Opera") > -1) return "Opera";
    if (userAgent.indexOf("Trident") > -1) // 'Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko'
    return "Internet Explorer";
    if (userAgent.indexOf("Edge") > -1) // 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299'
    return "Edge";
    if (userAgent.indexOf("Chrome") > -1) // 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36'
    return "Chrome";
    if (userAgent.indexOf("Safari") > -1) // 'Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306'
    return "Safari";
    return "unknown";
}
function $54b4d535c8b4d410$export$61fc7d43ac8f84b0(callback, wait, immediate) {
    let timeout = null;
    return function(...args) {
        const later = function() {
            timeout = null;
            if (!immediate) callback.apply(this, args);
        };
        const callNow = immediate && !timeout;
        window.clearTimeout(timeout);
        timeout = window.setTimeout(later, wait);
        if (callNow) callback.apply(this, args);
    };
}


/**
 * Mixin: Bind
 * -----------------------------------------------------------------------------
 * Mixin to set, remove and detect a class from a defined target.
 * - Useful to avoid multiple event binds when initialising components.
 *
 */ 
var /**
  * Create a new bind object.
  * @param {HTMLElement} element - HTML element to bind with a class.
  */ $3344b00a360931bc$export$2e2bcd8739ae039 = (element, config)=>{
    /**
    * Instance defaults settings.
    */ const defaults = {
        className: "post-init"
    };
    /**
    * Instance settings.
    */ const settings = (0, $54b4d535c8b4d410$export$c72c4b7feb522769)(defaults, config);
    /**
    * Set bind class on target.
    */ function set() {
        if (!element.length) {
            element.classList.add(settings.className);
            return;
        }
        [
            ...element
        ].forEach((item)=>{
            item.classList.add(settings.className);
        });
    }
    /**
    * Remove bind class on target.
    */ function remove() {
        if (!element.length) {
            element.classList.remove(settings.className);
            return;
        }
        [
            ...element
        ].forEach((item)=>{
            item.classList.remove(settings.className);
        });
    }
    /**
    * Check if element has already been initialised.
    */ function isSet() {
        if (!element.length) return element.classList.contains(settings.className);
        return [
            ...element
        ].every((item)=>{
            return item.classList.contains(settings.className);
        });
    }
    /**
    * Expose public interface.
    */ return Object.freeze({
        isSet: isSet,
        remove: remove,
        set: set
    });
};


/**
 * DOM selectors.
 */ const $d639514057d78f10$var$selectors = {
    control: '[js-accordion="control"]',
    item: '[js-accordion="item"]',
    content: '[js-accordion="content"]'
};
var /**
 * Export a new accordion instance.
 * @param {string} selector - The accordion item.
 * @param {object} config - Configuration.
 */ $d639514057d78f10$export$2e2bcd8739ae039 = (selector, config)=>{
    /**
   * Instance default settings.
   */ const defaults = {
        aria: true,
        singleOpen: true,
        showInitial: false,
        showAll: false,
        responsive: []
    };
    /**
   * Instance settings.
   */ const settings = (0, $54b4d535c8b4d410$export$c72c4b7feb522769)(defaults, config);
    /**
   * DOM node selectors.
   */ const nodeSelectors = {
        container: document.querySelector(selector),
        controls: [
            ...document.querySelector(selector).querySelectorAll($d639514057d78f10$var$selectors.control)
        ],
        items: [
            ...document.querySelector(selector).querySelectorAll($d639514057d78f10$var$selectors.item)
        ]
    };
    /**
   * Initialise component bind.
   */ const binder = (0, $3344b00a360931bc$export$2e2bcd8739ae039)(nodeSelectors.container);
    /**
   * Initialise component.
   */ function init() {
        if (binder.isSet()) return;
        if (settings.aria) setARIA();
        if (settings.showAll) showAllItems();
        if (settings.showInitial) showInitialItem();
        if (settings.responsive.length) setResponsiveEvents();
        setClickEvents();
        binder.set();
    }
    /**
   * Set click events on items.
   */ function setClickEvents() {
        nodeSelectors.controls.forEach((item)=>{
            (0, $54b4d535c8b4d410$export$af631764ddc44097)("click", item, (event)=>onItemClick(event, item.parentNode));
            lastNodeMargin(item.parentNode);
        });
    }
    /**
   * Handle toggle event on accordion control click.
   * @param {Event} event - Click event.
   * @param {HTMLElement} element - The accordion item.
   */ function onItemClick(event, element) {
        event.preventDefault();
        toggleElement(element);
    }
    function lastNodeMargin(container) {
        if (container.querySelector(".accordion__content").lastElementChild) {
            const lastChild = container.querySelector(".accordion__content").lastElementChild;
            lastChild.style.marginBottom = "0px";
        }
    }
    /**
   * Show targeted item and set ARIA values.
   * @param {HTMLElement} element - The accordion item.
   */ function showItem(element) {
        element.classList.add((0, $4da88745b4eecfc5$export$2e2bcd8739ae039).active);
        const child = element.querySelector(".accordion__content");
        child.style.maxHeight = "10000px";
        child.classList.add((0, $4da88745b4eecfc5$export$2e2bcd8739ae039).active);
        if (settings.aria) updateARIA(element, true);
    }
    /**
   * Hide targeted item and set ARIA values.
   * @param {HTMLElement} element - The accordion item.
   */ function hideItem(element) {
        const child = element.querySelector(".accordion__content");
        child.style.maxHeight = "0px";
        child.classList.remove((0, $4da88745b4eecfc5$export$2e2bcd8739ae039).active);
        element.classList.remove((0, $4da88745b4eecfc5$export$2e2bcd8739ae039).active);
        if (settings.aria) updateARIA(element, false);
    }
    /**
   * Check if item is active.
   * @param {HTMLElement} element - The accordion item.
   */ function isItemActive(element) {
        return element.classList.contains((0, $4da88745b4eecfc5$export$2e2bcd8739ae039).active);
    }
    /**
   * Hide all unselected items.
   * @param {HTMLElement} element - The accordion item.
   */ function hideUnselected(element) {
        nodeSelectors.items.forEach((item)=>{
            if (isItemActive(item) && item !== element) hideItem(item);
        });
    }
    /**
   * Show all items on init.
   */ function showAllItems() {
        nodeSelectors.items.forEach((element)=>{
            showItem(element);
        });
    }
    /**
   * Show initial item on init.
   */ function showInitialItem() {
        nodeSelectors.items.forEach((element, index)=>{
            if (index === 0) {
                showItem(element);
                return;
            }
            hideItem(element);
        });
    }
    /**
   * Hide all items.
   */ function hideAllItems() {
        nodeSelectors.items.forEach((item)=>{
            hideItem(item);
        });
    }
    /**
   * Toggle targeted item.
   * @param {HTMLElement} element - The accordion item.
   */ function toggleElement(element) {
        if (settings.singleOpen) hideUnselected(element);
        if (isItemActive(element)) {
            hideItem(element);
            return;
        }
        showItem(element);
    }
    /**
   * Create ARIA attributes.
   */ function setARIA() {
        nodeSelectors.container.setAttribute("role", "tablist");
        nodeSelectors.container.setAttribute("aria-label", "Accordion Control Group Buttons");
        nodeSelectors.items.forEach((item)=>{
            if (isItemActive(item)) {
                updateARIA(item, true);
                return;
            }
            updateARIA(item, false);
        });
    }
    /**
   * Update ARIA.
   * @param {HTMLElement} element - The accordion item.
   * @param {Boolean} value - Aria value.
   */ function updateARIA(element, value) {
        element.setAttribute("aria-selected", value);
        element.querySelector($d639514057d78f10$var$selectors.control).setAttribute("aria-expanded", value);
        element.querySelector($d639514057d78f10$var$selectors.content).setAttribute("aria-hidden", !value);
        if (!itemHasContentId(element)) updateARIAContentId(element);
    }
    /**
   * Check if ARIA control contains content id.
   * @param {HTMLElement} element - The accordion item.
   */ function itemHasContentId(element) {
        return element.querySelector($d639514057d78f10$var$selectors.control).hasAttribute("aria-controls");
    }
    /**
   * Update ARIA content id.
   * @param {HTMLElement} element - Click The accordion item.
   */ function updateARIAContentId(element) {
        const contentId = element.querySelector($d639514057d78f10$var$selectors.content).id;
        element.querySelector($d639514057d78f10$var$selectors.control).setAttribute("aria-controls", contentId);
    }
    /**
   * Set window resize events for responsive initialisation.
   */ function setResponsiveEvents() {
        handleResizeEvent();
        (0, $54b4d535c8b4d410$export$af631764ddc44097)("resize", (0, $66225070125f262f$export$2e2bcd8739ae039)(handleResizeEvent, 250));
    }
    /**
   * Handle resize events through debounce callback.
   * - Execute mobile callbacks.
   */ function handleResizeEvent() {
        settings.responsive.forEach((query)=>{
            if (window.matchMedia(`(min-width: ${query.breakpoint})`).matches) {
                reinit(query.settings);
                return;
            }
            reinit(settings);
        });
    }
    /**
   * Reinitialise component with options.
   * @param {Object} options - Options to use instead of defined settings.
   */ function reinit(options) {
        if (options.showAll) showAllItems();
        else hideAllItems();
    }
    /**
   * Expose public interface.
   */ return Object.freeze({
        init: init,
        hideAllItems: hideAllItems,
        showAllItems: showAllItems,
        showInitialItem: showInitialItem
    });
};


const $69ec42f0a830a054$var$accordionCl = {
    wrapper: "nested-accordion-js",
    tab: "nested-accordion-tab-js",
    tabActiveIcon: "nested-accordion-active-icon-js",
    content: "nested-accordion-content-js"
};
const $69ec42f0a830a054$var$handleTabContent = function(clickedTab, accordionParent) {
    const clickedTabNumber = clickedTab.getAttribute("data-accordion-number");
    const clickedTabLevel = clickedTab.parentElement.getAttribute("data-accordion-level");
    const clickedTabSiblings = [
        ...clickedTab.parentElement.children
    ].filter((child)=>child.getAttribute("data-accordion-number") === clickedTabNumber);
    const activeAccordions = [
        ...accordionParent.querySelectorAll("[data-accordion-active]")
    ];
    // if no accordions are currently open
    if (activeAccordions.length < 1) {
        const filteredSiblings = clickedTabSiblings.filter((child)=>child != clickedTab);
        filteredSiblings.forEach((sibling)=>sibling.style.height = sibling.scrollHeight + "px");
        clickedTab.classList.add($69ec42f0a830a054$var$accordionCl.tabActiveIcon);
        clickedTab.setAttribute("aria-expanded", "true");
        clickedTab.setAttribute("data-accordion-active", "");
        return;
    }
    // if the clicked tab is already active, so close it
    if (clickedTab.hasAttribute("data-accordion-active")) {
        const filteredSiblings = clickedTabSiblings.filter((child)=>child != clickedTab);
        filteredSiblings.forEach((sibling)=>sibling.style.height = "0px");
        if (clickedTabLevel === "nested-level") clickedTab.parentElement.style.height = clickedTab.scrollHeight + "px";
        clickedTab.classList.remove($69ec42f0a830a054$var$accordionCl.tabActiveIcon);
        clickedTab.setAttribute("aria-expanded", "false");
        clickedTab.removeAttribute("data-accordion-active");
        return;
    }
    // if the clicked tab is top-level, close all the other top level accordions
    if (clickedTabLevel === "top-level") {
        [
            ...clickedTab.parentElement.children
        ].forEach((child)=>{
            if (child.hasAttribute("data-accordion-active")) {
                child.classList.remove($69ec42f0a830a054$var$accordionCl.tabActiveIcon);
                child.setAttribute("aria-expanded", "false");
                child.removeAttribute("data-accordion-active");
            }
            if (child.getAttribute("data-accordion-level") === "nested-level") {
                child.style.height = "0px";
                child.firstElementChild.removeAttribute("data-accordion-active");
                child.firstElementChild.classList.remove($69ec42f0a830a054$var$accordionCl.tabActiveIcon);
            }
        });
        clickedTab.classList.add($69ec42f0a830a054$var$accordionCl.tabActiveIcon);
        const filteredSiblings = clickedTabSiblings.filter((child)=>child != clickedTab);
        filteredSiblings.forEach((sibling)=>sibling.style.height = sibling.firstElementChild.scrollHeight + "px");
        clickedTab.setAttribute("aria-expanded", "true");
        clickedTab.setAttribute("data-accordion-active", "");
        return;
    }
    // if the clicked tab is nested-level, close all the other sibling accordions
    if (clickedTabLevel === "nested-level") {
        [
            ...accordionParent.querySelectorAll("[data-accordion-level = nested-level]")
        ].forEach((acc)=>{
            if (acc.getAttribute("data-accordion-number") === clickedTabNumber) {
                const firstChild = acc.firstElementChild;
                acc.style.height = acc.firstElementChild.scrollHeight + "px";
                firstChild.setAttribute("aria-expanded", "false");
                firstChild.removeAttribute("data-accordion-active");
                firstChild.classList.remove($69ec42f0a830a054$var$accordionCl.tabActiveIcon);
            }
        });
        clickedTab.classList.add($69ec42f0a830a054$var$accordionCl.tabActiveIcon);
        const filteredSiblings = clickedTabSiblings.filter((child)=>child != clickedTab);
        filteredSiblings.forEach((sibling)=>sibling.style.height = sibling.scrollHeight + "px");
        const newContainerHeight = clickedTabSiblings.reduce((acc, child)=>child.scrollHeight + acc, 0);
        clickedTab.parentElement.style.height = newContainerHeight + "px";
        clickedTab.setAttribute("aria-expanded", "true");
        clickedTab.setAttribute("data-accordion-active", "");
        return;
    }
};
const $69ec42f0a830a054$var$handleAccordionOnResize = function(accordionParent, accordionsCollapsed) {
    if (accordionsCollapsed) return true;
    const allActiveAccordions = [
        ...accordionParent.querySelectorAll("[data-accordion-active]")
    ].reverse();
    allActiveAccordions.forEach((acc)=>{
        if (acc.parentElement.getAttribute("data-accordion-level") === "top-level") {
            acc.parentElement.querySelectorAll(`div[data-accordion-number = "${acc.getAttribute("data-accordion-number")}"]`).forEach((nested)=>nested.style.height = 0);
            acc.removeAttribute("data-accordion-active");
            acc.classList.remove($69ec42f0a830a054$var$accordionCl.tabActiveIcon);
        }
        if (acc.parentElement.getAttribute("data-accordion-level") === "nested-level") {
            acc.removeAttribute("data-accordion-active");
            acc.nextElementSibling.style.height = "0";
            acc.parentElement.style.height = "" + acc.scrollHeight + "px";
            acc.classList.remove($69ec42f0a830a054$var$accordionCl.tabActiveIcon);
        }
    });
    return true;
};
function $69ec42f0a830a054$export$2e2bcd8739ae039() {
    const accordionParent = document.querySelector("." + $69ec42f0a830a054$var$accordionCl.wrapper);
    let accordionsCollapsed = true;
    if (!accordionParent) return;
    accordionParent.addEventListener("click", (e)=>{
        const clickedTab = e.target.closest("." + $69ec42f0a830a054$var$accordionCl.tab);
        if (!clickedTab) return;
        accordionsCollapsed = false;
        $69ec42f0a830a054$var$handleTabContent(clickedTab, accordionParent);
    });
    let windowWidth = window.innerWidth;
    window.addEventListener("resize", (e)=>{
        if (windowWidth === window.innerWidth) return;
        accordionsCollapsed = $69ec42f0a830a054$var$handleAccordionOnResize(accordionParent, accordionsCollapsed);
        if (accordionsCollapsed) windowWidth = window.innerWidth;
    });
}


//# sourceMappingURL=tp.widget.bootstrap.min.js.map

function $f4b63d34fd72f100$export$2e2bcd8739ae039() {
    !function n(s, o, r) {
        function a(t, e) {
            if (!o[t]) {
                if (!s[t]) {
                    var i = undefined;
                    if (!e && i) return i(t, !0);
                    if (l) return l(t, !0);
                    throw (e = new Error("Cannot find module '" + t + "'")).code = "MODULE_NOT_FOUND", e;
                }
                i = o[t] = {
                    exports: {}
                }, s[t][0].call(i.exports, function(e) {
                    return a(s[t][1][e] || e);
                }, i, i.exports, n, s, o, r);
            }
            return o[t].exports;
        }
        for(var l = undefined, e = 0; e < r.length; e++)a(r[e]);
        return a;
    }({
        1: [
            function(e, t, i) {
                "use strict";
                Object.defineProperty(i, "__esModule", {
                    value: !0
                });
                i.EMPTY_WIDGET_ID = "000000000000000000000000", i.LAZY_LOADED_WIDGETS = [
                    "54d39695764ea907c0f34825",
                    "577258fb31f02306e4e3aaf9"
                ];
            },
            {}
        ],
        2: [
            function(e, t, i) {
                "use strict";
                var d = !1;
                function c(e) {
                    try {
                        if (d) return;
                        var t = document.createElement("script");
                        t.setAttribute("type", "application/ld+json"), t.innerHTML = JSON.stringify(e), document.head.appendChild(document.createComment("Added by Trustpilot")), document.head.appendChild(t), document.head.appendChild(document.createComment("/Added by Trustpilot")), d = !0;
                    } catch (e) {}
                }
                var h = e("./xhr.js");
                t.exports = function(e) {
                    if (d) return !1;
                    var t, i, n, s, o, r, a, l, u = "60f537b5b0f1639de1fe048c" === e.templateId;
                    return e.schemaType && e.location ? (r = (o = e).businessunitId, a = o.location, l = o.locale, o = o.templateId, o = [
                        "url=" + encodeURIComponent(window.location.href),
                        "templateId=" + o,
                        "locale=" + l
                    ].join("&"), h.xhrGet({
                        url: "https://widget.trustpilot.com" + ("/data/jsonld/business-unit/" + r + "/location/" + a) + "?" + o,
                        success: function(e) {
                            e.url = document.location.href, e["@id"] = document.location.href, c(e);
                        },
                        error: function(e) {
                            console.error(e);
                        }
                    }), !0) : !(!e.sku || !(e.name || u && "Product" === e.schemaType)) && (r = (l = e).businessunitId, a = l.locale, o = l.templateId, u = l.name, e = l.sku, t = l.reviewnumber, i = l.price, n = l.priceCurrency, l = l.availability, a = a && a.split("-")[0], r = "https://widget.trustpilot.com" + ("5763bccae0a06d08e809ecbb" === o ? "/data/jsonld/business-unit/" + r + "/product-imported" : "/data/jsonld/business-unit/" + r + "/product") + "?sku=" + encodeURIComponent(e) + "&numberOfReviews=" + (t || 10) + (u ? "&productName=" + encodeURIComponent(u) : "") + "&language=" + a + "&templateId=" + o + "&url=" + encodeURIComponent(window.location.origin + window.location.pathname), s = i && n && l ? {
                        "@type": "Offer",
                        priceCurrency: n,
                        price: i,
                        availability: l
                    } : null, h.xhrGet({
                        url: r,
                        success: function(e) {
                            s && (e.offers = s), (e.offers || e.review || e.aggregateRating) && c(e);
                        },
                        error: function(e) {
                            console.error(e);
                        }
                    }), !0);
                };
            },
            {
                "./xhr.js": 7
            }
        ],
        3: [
            function(e, t, i) {
                "use strict";
                Object.defineProperty(i, "__esModule", {
                    value: !0
                });
                var n = function(e, t, i) {
                    return t && s(e.prototype, t), i && s(e, i), e;
                };
                function s(e, t) {
                    for(var i = 0; i < t.length; i++){
                        var n = t[i];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                var o = a(e("./snippets")), r = a(e("./widget"));
                function a(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                n(l, [
                    {
                        key: "initializeOnPageLoad",
                        value: function() {
                            "loading" !== this.document.readyState ? this.findAndApplyWidgets() : this.document.addEventListener("DOMContentLoaded", this.findAndApplyWidgets.bind(this));
                        }
                    },
                    {
                        key: "applyWidgetFromDomElement",
                        value: function(e, t) {
                            e.firstChild && "IFRAME" === e.firstChild.tagName && !t || this.createWidget(e);
                        }
                    },
                    {
                        key: "findAndApplyWidgets",
                        value: function() {
                            var t = this, e = (this.stats.findAndApplyCalls += 1, this.widgetElements);
                            e && 0 !== e.length && (this.stats.elements = e.length, e.forEach(function(e) {
                                return t.createWidget(e);
                            }));
                        }
                    },
                    {
                        key: "createWidget",
                        value: function(e) {
                            this.removeWidget(e);
                            var t = e.dataset;
                            (0, o.default)(t);
                            e = new r.default({
                                container: e,
                                dataset: t
                            });
                            return e.initialize(), this.stats.applied += 1, this.stats.applyFromDomCalls += 1, this.widgets.push(e), e;
                        }
                    },
                    {
                        key: "removeWidget",
                        value: function(t) {
                            for(; t.firstChild;)t.removeChild(t.firstChild);
                            this.widgets.filter(function(e) {
                                return e.isLazyLoaded && e.isSameNodeAs(t);
                            }).forEach(function(e) {
                                e.destroy();
                            });
                        }
                    },
                    {
                        key: "closePopups",
                        value: function() {
                            this.widgets.forEach(function(e) {
                                return e.closePopup();
                            });
                        }
                    },
                    {
                        key: "businessUnitId",
                        get: function() {
                            return this.widgetElements[0].dataset.businessunitId;
                        }
                    },
                    {
                        key: "widgetElements",
                        get: function() {
                            return [].slice.call(this.document.getElementsByClassName("trustpilot-widget"));
                        }
                    }
                ]);
                e = l;
                function l(e, t, i) {
                    if (!(this instanceof l)) throw new TypeError("Cannot call a class as a function");
                    this.window = e, this.document = t, this.widgets = [], this.stats = {
                        applied: 0,
                        findAndApplyCalls: 0,
                        applyFromDomCalls: 0,
                        elements: 0
                    }, this.version = i;
                }
                i.default = e;
            },
            {
                "./snippets": 2,
                "./widget": 5
            }
        ],
        4: [
            function(e, t, i) {
                "use strict";
                Object.defineProperty(i, "__esModule", {
                    value: !0
                });
                var n = Object.assign || function(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var i, n = arguments[t];
                        for(i in n)Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
                    }
                    return e;
                }, s = function(e, t, i) {
                    return t && o(e.prototype, t), i && o(e, i), e;
                };
                function o(e, t) {
                    for(var i = 0; i < t.length; i++){
                        var n = t[i];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                var r = "53aa8912dec7e10d38f59f36,539adbd6dec7e10e686debee,539ad60defb9600b94d7df2c,539ad998dec7e10e686debe0,539ad0ffdec7e10e686debd7,54d0e1d8764ea9078c79e6ee,54ad5defc6454f065c28af8b".split(",");
                function a(e) {
                    var t = "";
                    return e && 0 < e.length && (e = e.toLowerCase(), t = /(px|\%)/i.test(e) ? e : e + "px"), t;
                }
                s(l, [
                    {
                        key: "getIframeOptionsFromData",
                        value: function() {
                            var e = this.iframeData || {
                                styles: {}
                            };
                            return n({}, this.defaultIframeOptions, {
                                position: e.styles.position || "",
                                zindex: e.styles.zindex || "",
                                margin: e.styles.margin || "",
                                top: e.styles.top || "",
                                bottom: e.styles.bottom || "",
                                left: e.styles.left || "",
                                right: e.styles.right || "",
                                height: e.styles.height || "",
                                width: e.styles.width || this.defaultIframeOptions.styles.width || "",
                                minWidth: e.styles.minWidth || "",
                                minHeight: e.styles.minHeight || "",
                                display: e.show ? "block" : "none",
                                src: this.baseUrl + e.source + this.queryString,
                                borderStyle: this.defaultIframeOptions.styles.borderStyle,
                                overflow: this.defaultIframeOptions.styles.overflow,
                                loading: this.dataset.loading,
                                allow: e.allow
                            });
                        }
                    },
                    {
                        key: "initialize",
                        value: function(e, t) {
                            var i, n;
                            this._iframe = (i = this.getIframeOptionsFromData(), (n = document.createElement("iframe")).style.position = i.position, n.style.zIndex = i.zindex, n.style.margin = i.margin, n.style.top = i.top, n.style.bottom = i.bottom, n.style.left = i.left, n.style.right = i.right, n.style.height = i.height, n.style.width = i.width, n.style.minHeight = i.minHeight, n.style.minWidth = i.minWidth, n.style.borderStyle = i.borderStyle, n.style.backgroundColor = i.backgroundColor, n.style.display = i.display, n.style.overflow = i.overflow, n.allowTransparency = i.allowTransparency, n.title = "Customer reviews powered by Trustpilot", n.loading = i.loading || "auto", n.src = i.src, i.allow && (n.allow = i.allow), n), e.appendChild(this._iframe), this._iframe.addEventListener("load", t);
                        }
                    },
                    {
                        key: "sendMessage",
                        value: function(e) {
                            this._iframe.contentWindow && (e = JSON.stringify(e), this._iframe.contentWindow.postMessage(e, "https://widget.trustpilot.com"));
                        }
                    },
                    {
                        key: "isInViewport",
                        value: function(e) {
                            var t = this._iframe.getBoundingClientRect(), i = t.width || this._iframe.offsetWidth, n = t.height || this._iframe.offsetHeight;
                            return 0 <= t.top && 0 <= t.left && t.bottom - n * e <= (window.innerHeight || document.documentElement.clientHeight) && t.right - i * e <= (window.innerWidth || document.documentElement.clientWidth);
                        }
                    },
                    {
                        key: "setWidgetId",
                        value: function(e) {
                            this.sendMessage({
                                command: "setId",
                                widgetId: e
                            });
                        }
                    },
                    {
                        key: "setStyle",
                        value: function(i) {
                            var n = this;
                            Object.keys(i).forEach(function(e) {
                                var t = i[e];
                                n._iframe.style[e] = t;
                            });
                        }
                    },
                    {
                        key: "isScrollBlockingPopup",
                        value: function() {
                            return "popup" === this.name && this.isScrollBlocking;
                        }
                    },
                    {
                        key: "disablePageScroll",
                        value: function() {
                            this.defaultOverflowProperties = this.OVERFLOW_PROPERTIES.reduce(function(e, t) {
                                return e[t] = document.body.style.getPropertyValue(t), e;
                            }, {}), document.body.style.overflow = "hidden";
                        }
                    },
                    {
                        key: "restorePageScroll",
                        value: function() {
                            var e = !0, t = !1, i = void 0;
                            try {
                                for(var n, s = this.OVERFLOW_PROPERTIES[Symbol.iterator](); !(e = (n = s.next()).done); e = !0){
                                    var o = n.value;
                                    document.body.style.removeProperty(o), this.defaultOverflowProperties[o] && document.body.style.setProperty(o, this.defaultOverflowProperties[o]);
                                }
                            } catch (e) {
                                t = !0, i = e;
                            } finally{
                                try {
                                    !e && s.return && s.return();
                                } finally{
                                    if (t) throw i;
                                }
                            }
                        }
                    },
                    {
                        key: "show",
                        value: function() {
                            this.isScrollBlockingPopup() && !this.isVisible && this.disablePageScroll(), this._iframe.style.display = "block", this.isVisible = !0;
                        }
                    },
                    {
                        key: "hide",
                        value: function() {
                            this.isScrollBlockingPopup() && this.isVisible && this.restorePageScroll(), this._iframe.style.display = "none", this.isVisible = !1;
                        }
                    },
                    {
                        key: "focus",
                        value: function() {
                            this._iframe.contentWindow.focus();
                        }
                    },
                    {
                        key: "resizeHeight",
                        value: function(e) {
                            "number" == typeof e && 0 !== e && (this._iframe.style.height = e + "px");
                        }
                    },
                    {
                        key: "_shouldAllowRobots",
                        value: function() {
                            return "true" === this.dataset.allowRobots && this.dataset.location && -1 < r.indexOf(this.templateId);
                        }
                    },
                    {
                        key: "dimensions",
                        get: function() {
                            return {
                                height: a(this.dataset.styleHeight),
                                width: a(this.dataset.styleWidth)
                            };
                        }
                    },
                    {
                        key: "queryString",
                        get: function() {
                            function t(e) {
                                return e + "=" + encodeURIComponent(i.dataset[e]);
                            }
                            function e(e) {
                                return Object.keys(i.dataset).filter(e).map(t);
                            }
                            var i = this, n = [
                                "businessunitId",
                                "templateId"
                            ], s = e(function(e) {
                                return -1 !== n.indexOf(e);
                            }), o = e(function(e) {
                                return -1 === n.indexOf(e) && "allowRobots" !== e;
                            });
                            return "?" + s.join("&") + "#" + o.join("&");
                        }
                    },
                    {
                        key: "templateId",
                        get: function() {
                            return this.dataset.templateId;
                        }
                    },
                    {
                        key: "baseUrl",
                        get: function() {
                            return "https://widget.trustpilot.com/trustboxes/" + this.templateId + "/";
                        }
                    },
                    {
                        key: "defaultIframeOptions",
                        get: function() {
                            return {
                                source: this._shouldAllowRobots() ? "index_allow_robots.html" : "index.html",
                                allowTransparency: "true",
                                styles: {
                                    borderStyle: "none",
                                    backgroundColor: "transparent",
                                    display: "block",
                                    overflow: "hidden",
                                    height: this.dimensions.height,
                                    width: this.dimensions.width,
                                    position: "relative"
                                },
                                show: !0
                            };
                        }
                    }
                ]);
                s = l;
                function l(e, t, i) {
                    var n = 3 < arguments.length && void 0 !== arguments[3] && arguments[3], s = this, o = l;
                    if (!(s instanceof o)) throw new TypeError("Cannot call a class as a function");
                    this.OVERFLOW_PROPERTIES = [
                        "overflow",
                        "overflow-x",
                        "overflow-y"
                    ], this.name = e, this.dataset = t, this.iframeData = i || this.defaultIframeOptions, this.defaultOverflowProperties = {}, this.isVisible = !1, this.isScrollBlocking = n;
                }
                i.default = s;
            },
            {}
        ],
        5: [
            function(e, r, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var i = function(e, t, i) {
                    return t && n(e.prototype, t), i && n(e, i), e;
                };
                function n(e, t) {
                    for(var i = 0; i < t.length; i++){
                        var n = t[i];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                var l = s(e("./tracking")), o = s(e("./iframe")), u = e("./../constants");
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                i(d, null, [
                    {
                        key: "generateId",
                        value: function() {
                            for(var e = this.usedIds, t = void 0; t = Math.random(), -1 !== e.indexOf(t););
                            return this.usedIds.push(t);
                        }
                    }
                ]), i(d, [
                    {
                        key: "isContainerInViewport",
                        value: function() {
                            var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 200, t = this.container.getBoundingClientRect(), i = t.width || this.container.offsetWidth, n = t.height || this.container.offsetHeight;
                            return 0 <= t.top && 0 <= t.left && t.bottom - n - e <= (window.innerHeight || document.documentElement.clientHeight) && t.right - i - e <= (window.innerWidth || document.documentElement.clientWidth);
                        }
                    },
                    {
                        key: "initialize",
                        value: function() {
                            !this.isLazyLoaded || this.isContainerInViewport() ? (this._widgetIFrameOrigin = "https://widget.trustpilot.com", this.createIFrame("main"), this.attachMessageListener()) : this.lazyLoadTimeout = setTimeout(this.initialize, 500);
                        }
                    },
                    {
                        key: "handleCommand",
                        value: function(e) {
                            var t = e.data, e = e.origin;
                            try {
                                var i = "string" == typeof t ? JSON.parse(t) : t;
                                return e === this._widgetIFrameOrigin && i.widgetId === this.id ? this.widgetIframeMessageHandler(i) : !1;
                            } catch (e) {
                                return !1;
                            }
                        }
                    },
                    {
                        key: "attachMessageListener",
                        value: function() {
                            window.addEventListener("message", this.handleCommand.bind(this), !1);
                        }
                    },
                    {
                        key: "widgetIframeMessageHandler",
                        value: function(e) {
                            var t = this, i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : function() {}, n = (this.stats.events[e.command] = (this.stats.events[e.command] || 0) + 1, e.name), s = e.style, o = e.height, r = e.targets, u = e.attachToBody, a = this.iframes[n], l = {
                                createIFrame: function() {
                                    return t.createIFrame(n, e, u);
                                },
                                setStyle: function() {
                                    return a.setStyle(s);
                                },
                                show: function() {
                                    return a.show();
                                },
                                hide: function() {
                                    return a.hide();
                                },
                                focus: function() {
                                    return a.focus();
                                },
                                loaded: function() {
                                    return t.iframes.main.sendMessage("loaded");
                                },
                                message: function() {
                                    return a.sendMessage(e);
                                },
                                ping: function() {
                                    t.iframes.main.sendMessage({
                                        command: "pong"
                                    }), t.stats.pongSent = !0;
                                },
                                "resize-height": function() {
                                    return t.getIframeOrMain(n).resizeHeight(o);
                                },
                                impression: function() {
                                    return t.tracking.initialize();
                                },
                                scrollTo: function() {
                                    return t.scrollToTrustBox(r);
                                }
                            }[e.command];
                            return l ? (l(), !0) : (i(), !1);
                        }
                    },
                    {
                        key: "createIFrame",
                        value: function(e, t) {
                            var i = this, n = 2 < arguments.length && void 0 !== arguments[2] && arguments[2], s = new o.default(e, this.dataset, t, n);
                            this.iframes[e] = s, this.stats.createIFrameCalls += 1, s.initialize(n ? document.body : this.container, function() {
                                s.setWidgetId(i.id), i.stats.iframeLoadEvents += 1;
                            });
                        }
                    },
                    {
                        key: "getIframeOrMain",
                        value: function(e) {
                            return this.iframes[e] || this.iframes.main;
                        }
                    },
                    {
                        key: "isInViewport",
                        value: function(e) {
                            return this.iframes.main.isInViewport(e);
                        }
                    },
                    {
                        key: "isSameNodeAs",
                        value: function(e) {
                            try {
                                return this.container.isSameNode(e);
                            } catch (e) {
                                return !1;
                            }
                        }
                    },
                    {
                        key: "destroy",
                        value: function() {
                            this.lazyLoadTimeout && clearTimeout(this.lazyLoadTimeout);
                        }
                    },
                    {
                        key: "closePopup",
                        value: function() {
                            "popup" in this.iframes && (this.iframes.main.sendMessage({
                                name: "main",
                                command: "message",
                                message: "popup toggled",
                                visible: !1
                            }), this.iframes.popup.hide());
                        }
                    },
                    {
                        key: "scrollToTrustBox",
                        value: function() {
                            var e, t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : [], t = document.querySelector(t.map(function(e) {
                                return "[data-template-id='" + e + "']";
                            }).join(","));
                            !t || (e = t.querySelector("iframe")) && (t.scrollIntoView({
                                behavior: "smooth"
                            }), e.contentWindow.focus());
                            (0, $d639514057d78f10$export$2e2bcd8739ae039)(".accordion--product-reviews").showInitialItem();
                        }
                    },
                    {
                        key: "id",
                        get: function() {
                            return this._id || (this._id = this.constructor.generateId()), this._id;
                        }
                    }
                ]);
                e = d;
                function d(e) {
                    var t = this, i = e.container, n = e.dataset, s = e.session, o = e.anonymousId, r = e.testId, e = e.sessionExpiry;
                    if (!(this instanceof d)) throw new TypeError("Cannot call a class as a function");
                    var a = {
                        container: i,
                        dataset: n,
                        templateId: n.templateId,
                        businessUnitId: n.businessunitId,
                        locale: n.locale
                    };
                    Object.keys(a).forEach(function(e) {
                        if (!a[e]) throw "No " + e + " supplied for TrustBox";
                    }), this.container = i, this.container.style.position = "relative", this.dataset = n, this.iframes = {}, this.tracking = new l.default(function(e) {
                        return t.iframes.main.sendMessage(e);
                    }, function() {
                        return t.isInViewport(0.5);
                    }, {
                        session: s,
                        group: n.group,
                        sessionExpiry: e,
                        anonymousId: o,
                        testId: r,
                        templateId: n.templateId
                    }), this.isLazyLoaded = -1 < u.LAZY_LOADED_WIDGETS.indexOf(n.templateId), this.lazyLoadTimeout = null, this.isSameNodeAs = this.isSameNodeAs.bind(this), this.destroy = this.destroy.bind(this), this.stats = {
                        createIFrameCalls: 0,
                        iframeLoadEvents: 0,
                        events: {},
                        pongSent: !1
                    }, this.initialize = this.initialize.bind(this);
                }
                e.usedIds = [], t.default = e;
            },
            {
                "./../constants": 1,
                "./iframe": 4,
                "./tracking": 6
            }
        ],
        6: [
            function(e, t, i) {
                "use strict";
                Object.defineProperty(i, "__esModule", {
                    value: !0
                });
                var n = function(e, t, i) {
                    return t && s(e.prototype, t), i && s(e, i), e;
                };
                function s(e, t) {
                    for(var i = 0; i < t.length; i++){
                        var n = t[i];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                var u = e("../constants");
                n(l, [
                    {
                        key: "initialize",
                        value: function() {
                            this.sendImpressionData(), this.attachListener(), this.shouldDetachListener();
                        }
                    },
                    {
                        key: "getTrackingData",
                        value: function(e) {
                            e = {
                                command: e,
                                url: window.document.URL,
                                referrer: window.document.referrer,
                                userAgent: window.navigator.userAgent,
                                language: window.navigator.userLanguage || window.navigator.language,
                                platform: window.navigator.platform
                            };
                            return this.session && this.group && (e.session = this.session, e.sessionExpiry = this.sessionExpiry), this.anonymousId && (e.anonymousId = this.anonymousId), this.testId && (e.testId = this.testId), e;
                        }
                    },
                    {
                        key: "sendImpressionData",
                        value: function() {
                            var e;
                            this.hasSentImpression || (this.hasSentImpression = !0, e = this.getTrackingData("impression-received"), this.sendMessage(e));
                        }
                    },
                    {
                        key: "sendVisibilityData",
                        value: function() {
                            var e;
                            this.hasSentViewTracking || (this.hasSentViewTracking = !0, e = this.getTrackingData("trustbox-in-viewport"), this.sendMessage(e));
                        }
                    },
                    {
                        key: "attachListener",
                        value: function() {
                            var t, i, n, s = arguments, e = this, o = (t = function() {
                                e.templateId !== u.EMPTY_WIDGET_ID && !e.shouldDetachListener() || (window.removeEventListener("scroll", a, r), window.removeEventListener("resize", l, r));
                            }, function() {
                                var e = s;
                                clearTimeout(n), n = setTimeout(function() {
                                    n = null, t(e);
                                }, i);
                            }), r = {
                                passive: (n = void 0, true),
                                capture: (i = 100, false)
                            }, a = window.addEventListener("scroll", o, r), l = window.addEventListener("resize", o, r);
                            o();
                        }
                    },
                    {
                        key: "shouldDetachListener",
                        value: function() {
                            return !!this.hasSentViewTracking || (this.hasBeenVisible ? (this.hasSentImpression && this.sendVisibilityData(), !0) : !!this.isTrustBoxVisible() && (this.hasSentImpression ? (this.sendVisibilityData(), !0) : this.hasBeenVisible = !0));
                        }
                    }
                ]);
                e = l;
                function l(e, t, i) {
                    var n = i.session, s = i.sessionExpiry, o = i.group, r = i.anonymousId, a = i.testId, i = i.templateId;
                    if (!(this instanceof l)) throw new TypeError("Cannot call a class as a function");
                    this.hasSentImpression = !1, this.hasSentViewTracking = !1, this.sendMessage = e, this.isTrustBoxVisible = t, this.session = n, this.group = o, this.sessionExpiry = s, this.anonymousId = r, this.testId = a, this.templateId = i;
                }
                i.default = e;
            },
            {
                "../constants": 1
            }
        ],
        7: [
            function(e, t, i) {
                "use strict";
                function n(t) {
                    try {
                        return JSON.parse(t.responseText);
                    } catch (e) {
                        return t.responseText;
                    }
                }
                t.exports = {
                    xhrGet: function(e) {
                        var t = new window.XMLHttpRequest();
                        t.open("GET", e.url, !0), t.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), t.onreadystatechange = function() {
                            4 === t.readyState && (200 <= t.status && t.status < 300 ? e.success(n(t)) : e.error && e.error(n(t)));
                        }, t.send();
                    }
                };
            },
            {}
        ],
        8: [
            function(e, t, i) {
                "use strict";
                var n, s, o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, r = "1.419.0";
                try {
                    n = e("./lib/widget-management.js").default, s = window.Trustpilot && 0 < Object.keys(window.Trustpilot).length, window.Trustpilot = s ? window.Trustpilot : {
                        loadFromElement: function(e, t) {
                            if (e) return this.Modules.WidgetManagement && this.Modules.WidgetManagement.applyWidgetFromDomElement(e, t);
                            console.error('No element supplied to "Trustpilot.loadFromElement"');
                        }
                    }, window.Trustpilot.Modules = window.Trustpilot.Modules || {}, window.Trustpilot.Modules.WidgetManagement ? window.Trustpilot.Modules.WidgetManagement.version !== r && console.log("Detected legacy TrustBox bootstrap with version:", window.Trustpilot.Modules.WidgetManagement.version, ", current:", r) : (window.Trustpilot.Modules.WidgetManagement = new n(window, document, r), window.Trustpilot.Modules.WidgetManagement.initializeOnPageLoad(), window.addEventListener("load", function() {
                        try {
                            for(var e = document.getElementsByClassName("trustpilot-widget"), t = 0; t < e.length; ++t){
                                var i = e[t], n = i.firstChild && i.firstChild.tagName;
                                n && "IFRAME" !== n && window.Trustpilot.loadFromElement(i);
                            }
                        } catch (e) {
                            console.error("Error loading trustboxes " + e);
                        }
                    })), window.addEventListener("click", function() {
                        window.Trustpilot.Modules.WidgetManagement.closePopups();
                    });
                } catch (e) {
                    function a(e) {
                        console.error("Error on bootstrap:" + e);
                        e = [
                            "error=" + encodeURIComponent(e),
                            "uri=" + encodeURIComponent(document.URL),
                            "bootstrapVersion=" + r
                        ].join("&");
                        document.createElement("img").src = "https://widget.trustpilot.com/feedback/report-error?" + e;
                    }
                    try {
                        "object" === (void 0 === e ? "undefined" : o(e)) ? a(e.message) : a(e);
                    } catch (e) {
                        console.error("Error on error reporting method:" + e);
                    }
                }
            },
            {
                "./lib/widget-management.js": 3
            }
        ]
    }, {}, [
        8
    ]);
} //# sourceMappingURL=tp.widget.bootstrap.min.js.map


// bump
// import "./components/mobile-menu.js";
(0, $bd34b27e78603290$export$2e2bcd8739ae039)();
(0, $69ec42f0a830a054$export$2e2bcd8739ae039)();
// aria accordion - the whole document needs to be loaded first, otherwise the functions will calculate wrong element heights (showInitialItem())
window.addEventListener("load", (event)=>{
    let existingAccordions = [];
    // some mobile devices insert a scrollbar on scroll and then remove it, changing the width and firing the resize event (below is functionality trying to prevent it)
    let windowWidth = window.innerWidth;
    if (document.querySelector(".accordion--product-overview") != null) {
        (0, $d639514057d78f10$export$2e2bcd8739ae039)(".accordion--product-overview", {}).init();
        (0, $d639514057d78f10$export$2e2bcd8739ae039)(".accordion--product-overview").hideAllItems();
        (0, $d639514057d78f10$export$2e2bcd8739ae039)(".accordion--product-overview").showInitialItem();
        existingAccordions.push(".accordion--product-overview");
    }
    if (document.querySelector(".accordion--product-video") !== null) {
        (0, $d639514057d78f10$export$2e2bcd8739ae039)(".accordion--product-video", {}).init();
        (0, $d639514057d78f10$export$2e2bcd8739ae039)(".accordion--product-video").hideAllItems();
        existingAccordions.push(".accordion--product-video");
    }
    if (document.querySelector(".accordion--product-delivery") !== null) {
        (0, $d639514057d78f10$export$2e2bcd8739ae039)(".accordion--product-delivery", {}).init();
        (0, $d639514057d78f10$export$2e2bcd8739ae039)(".accordion--product-delivery").hideAllItems();
        existingAccordions.push(".accordion--product-delivery");
    }
    if (document.querySelector(".accordion--product-reviews") !== null) {
        (0, $d639514057d78f10$export$2e2bcd8739ae039)(".accordion--product-reviews", {}).init();
        (0, $d639514057d78f10$export$2e2bcd8739ae039)(".accordion--product-reviews").hideAllItems();
        (0, $d639514057d78f10$export$2e2bcd8739ae039)(".accordion--product-reviews").showInitialItem();
        existingAccordions.push(".accordion--product-reviews");
    }
    if (document.querySelector(".accordion--product-faq") !== null) {
        (0, $d639514057d78f10$export$2e2bcd8739ae039)(".accordion--product-faq", {}).init();
        (0, $d639514057d78f10$export$2e2bcd8739ae039)(".accordion--product-faq").hideAllItems();
        existingAccordions.push(".accordion--product-faq");
    }
    // aria mobile accordions only
    if (document.querySelector(".accordion--footer-links") !== null) mobileAccordionOnly(".accordion--footer-links");
    if (document.querySelector(".accordion--account-cards") !== null) mobileAccordionOnly(".accordion--account-cards", 990);
    function mobileAccordionOnly(accEl, breakpoint = 750) {
        if (window.innerWidth <= breakpoint) {
            (0, $d639514057d78f10$export$2e2bcd8739ae039)(accEl, {}).init();
            (0, $d639514057d78f10$export$2e2bcd8739ae039)(accEl).hideAllItems();
            existingAccordions.push(accEl);
        }
        const mediaQueryList = window.matchMedia(`(max-width: ${breakpoint}px)`);
        mediaQueryList.addEventListener("change", (event)=>{
            const selectedAcc = document.querySelector(accEl);
            if (selectedAcc !== null && event.matches) {
                (0, $d639514057d78f10$export$2e2bcd8739ae039)(accEl, {}).init();
                (0, $d639514057d78f10$export$2e2bcd8739ae039)(accEl).hideAllItems();
                existingAccordions.push(accEl);
            } else if (selectedAcc !== null) {
                selectedAcc.querySelectorAll(".accordion__content").forEach((content)=>content.style.height = "auto");
                existingAccordions = existingAccordions.filter((acc)=>acc !== accEl);
            }
        });
    }
    window.addEventListener("resize", (e)=>{
        if (windowWidth === window.innerWidth) return;
        setTimeout(()=>{
            existingAccordions.forEach((acc)=>(0, $d639514057d78f10$export$2e2bcd8739ae039)(acc).hideAllItems());
            windowWidth = window.innerWidth;
        }, 200);
    });
});
(0, $f4b63d34fd72f100$export$2e2bcd8739ae039)();
window.ecs = window.ecs || {};
window.ecs.getCartRecommendations = async ()=>{
    const baseUrl = window.Shopify?.routes?.root || "/";
    const fetchUrl = `${baseUrl}?section_id=cart-recommendations`;
    const response = await fetch(fetchUrl);
    if (!response.ok) return null;
    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const sectionContainer = doc.getElementById("shopify-section-cart-recommendations");
    const jsonText = sectionContainer?.textContent?.trim();
    if (!jsonText) return null;
    return JSON.parse(jsonText);
};

})();
//# sourceMappingURL=theme.js.map
